import { formatDate } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faMinus, faPlus, faAngleDown, faAngleUp, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { Beneficiaries } from 'src/app/shared/models/offer-models/beneficiaries.model';
import { ProductRoleService } from 'src/app/shared/services/admin-services/product-role.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BankService } from 'src/app/shared/services/admin-services/bank.service';
import { Filter } from 'src/app/shared/models/filter.model';
import { CalculatorService } from 'src/app/shared/services/calculator-services/calculator-standard-os.service';
import { Progresive } from 'src/app/shared/models/calculator-models/progresive.model';
import { ExportCalculatorService } from 'src/app/shared/services/calculator-services/calculator-export.service';
import { BasicInformationsService } from 'src/app/shared/services/basic-informations.service';
import { Subscription } from 'rxjs';
import { BasicInformations } from 'src/app/shared/models/basic-informations.model';
import { ProgressiveOffer } from 'src/app/shared/models/offer-models/progressive.model';
import { UserService } from 'src/app/shared/services/admin-services/user.service';
import { DigitalService } from 'src/app/shared/services/digital.service';
import { OfferService } from 'src/app/shared/services/offer-services/offer.service';
import { RoleSendService } from 'src/app/shared/services/role-send.service';
import { Router } from '@angular/router';
import { RiskAssessment } from 'src/app/shared/models/offer-models/risk-assessment.model';
import { SaveDraftService } from 'src/app/shared/services/save-draft.service';
import { EditOfferService } from 'src/app/shared/services/edit-offer.service';
import { FillDraftOfferService } from 'src/app/shared/services/fill-draft.service';

@Component({
  selector: 'app-progresive',
  templateUrl: './progresive.component.html',
  styleUrls: ['./progresive.component.sass']
})
export class ProgresiveComponent implements OnInit, OnDestroy {
  @ViewChild('insuredBlock', { static: false }) private insuredBlock;
  @ViewChild('usersBlock', { static: false }) private usersBlock: ElementRef;
  @ViewChild('healthBlock', { static: false }) private healthBlock: ElementRef;
  @ViewChild('fatcaBlock', { static: false }) private fatcaBlock: ElementRef;
  @ViewChild('spnftBlock', { static: false }) private spnftBlock: ElementRef;
  @ViewChild('platimatikBlock', { static: false }) private platimatikBlock: ElementRef;

  @ViewChild('alertModal', { static: false }) private alertModal;
  @ViewChild('emailModal', { static: false }) private emailModal;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('accNumber', { static: false }) private accNumber;
  @ViewChild('riskFormModal', { static: false }) private riskFormModal;

  faMinus = faMinus
  faPlus = faPlus
  faAngleDown = faAngleDown
  faAngleUp = faAngleUp
  faTrashAlt = faTrashAlt
  faTimesCircle = faTimesCircle
  faCheckCircle = faCheckCircle

  errorTitle: string;
  successTitle: string;

  basicInfoSubscription: Subscription;
  roleService: Subscription;
  editSubscription: Subscription;

  insuredSumANdPremimBool: boolean = true
  basicInsuranceBool: boolean = true

  supplementaryIsnuranceHideAllBool: boolean = false
  supplementaryInsuranceBool: boolean = true

  healthQuestionnaireBool: boolean = false;
  noticePersonalityBool: boolean = false;
  noticeFatcaBool: boolean = false;
  fatcaTypeBool: boolean = null;
  formSpnftBool: boolean = false;
  formPlatimatikBool: boolean = false;
  calculcatorUsersBool: boolean = false;

  validInsuranceAndSumPremium: boolean = false;
  validUser: boolean = false;
  validPLATIMATIK: boolean = false;
  validSPNFT: boolean = false;

  basketViewBool: boolean = false

  userValue: boolean
  hideExport: boolean = false

  todayDate = new Date();
  insuredSumAndPremiumForm: FormGroup = new FormGroup({
    insuranceStart: new FormControl({ value: '', disabled: true }),
    insuranceEnd: new FormControl({ value: '', disabled: true }),
    insurancePeriod: new FormControl('', [Validators.required]),
    accessAge: new FormControl('', [Validators.required]),
    dynamicsOfPayment: new FormControl('', [Validators.required]),
    oneTimePayment: new FormControl('0', [Validators.required]),
    cigarettesDaily: new FormControl('0', [Validators.required]),
    height: new FormControl('', [Validators.required]),
    weight: new FormControl('', [Validators.required]),
    currencyPayment: new FormControl('0', [Validators.required]),
    currencyPayout: new FormControl('0', [Validators.required]),
    methodPayment: new FormControl('', [Validators.required])
  })

  basicInfoForm = new FormGroup({
    premiumRate: new FormControl('', [Validators.required]),
    insuranceSum: new FormControl('', [Validators.required]),
    investingPack: new FormControl('', [Validators.required]),
    yearlyPremium: new FormControl({ value: '', disabled: true }),
    increaseRatePremium: new FormControl({ value: '', disabled: true }),
    percentIUyearly: new FormControl({ value: '', disabled: true }),
    contractedPremium: new FormControl({ value: '', disabled: true }),
    ipValue: new FormControl({ value: '', disabled: true }),
    noSupplementaryInsurance: new FormControl(false, [])
  })

  // Forma za Dopunsko osiguranje
  insuranceCoverageForm = new FormGroup({
    deathByAccident: new FormControl({ value: '', disabled: true }),
    disabilityByAccident: new FormControl({ value: '', disabled: true }),
    surgery: new FormControl({ value: '', disabled: true }),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    dailyFee: new FormControl({ value: '', disabled: true }),
    incidentRadio: new FormControl('3', [Validators.required]),
    premiumRateSupplementaryFirst: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementarySecound: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementaryThird: new FormControl({ value: '', disabled: true }),
    premiumRateSupplementaryForth: new FormControl({ value: '', disabled: true }),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecound: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumPremiumRateForth: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecound: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true }),
    sumYearlyForth: new FormControl({ value: '', disabled: true }),
    planRadio: new FormControl('3', {}),
    bidCheck: new FormControl('', []),
    ransomCheck: new FormControl('', []),
    forewordCheck: new FormControl('', []),
    insuranceConditionsCheck: new FormControl('', [])
  })

  // Forma za Personalizovano ponuda dopunskog osiguranja
  personalForm = new FormGroup({
    deathByAccident: new FormControl('', []),
    invalidityByAccident: new FormControl('', []),
    monthlyRent: new FormControl({ value: '', disabled: true }),
    daylyFee: new FormControl({ value: '', disabled: true }),
    treatmanExpenses: new FormControl({ value: '', disabled: true }),
    includeMSO: new FormControl({ value: '0', disabled: true }),
    includeDNA: new FormControl({ value: '0', disabled: true }),
    additionalInsurance: new FormControl({ value: '', disabled: true }),
    surgery: new FormControl({ value: '', disabled: true }),

    riderDeath: new FormControl(''),
    tbType: new FormControl(''),
    riderTB: new FormControl(''),

    planRadio: new FormControl('3', []),
    sumPremiumRateFirst: new FormControl({ value: '', disabled: true }),
    sumPremiumRateSecond: new FormControl({ value: '', disabled: true }),
    sumPremiumRateThird: new FormControl({ value: '', disabled: true }),
    sumYearlyFirst: new FormControl({ value: '', disabled: true }),
    sumYearlySecond: new FormControl({ value: '', disabled: true }),
    sumYearlyThird: new FormControl({ value: '', disabled: true })
  })

  // Lista korisnika
  insuranceUsers: Array<Beneficiaries> = [];
  // Forma za korisnike
  insuranceUserForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    remark: new FormControl('', [Validators.required]),
    role: new FormControl('', [Validators.required])
  })

  // Forma za Zdravstveni upitnik
  healthForm = new FormGroup({
    threeMonthStayAbroad: new FormControl('', [Validators.required]),
    threeMonthStayAbroadDescription: new FormControl('', [Validators.required]),
    deniedAcceptedRequest: new FormControl('', [Validators.required]),
    deniedacceptedRequestDescription: new FormControl('', [Validators.required]),
    sportActivity: new FormControl('', [Validators.required]),
    sportActivityDescription: new FormControl('', [Validators.required]),
    constantDoctorTreats: new FormControl('', [Validators.required]),
    constantDoctorTreatsDescription: new FormControl('', [Validators.required]),
    specialMedicalExamination: new FormControl('', [Validators.required]),
    specialMedicalExaminationDescription: new FormControl('', [Validators.required]),
    takingMedicines: new FormControl('', [Validators.required]),
    takingMedicinesDescription: new FormControl('', [Validators.required]),
    alcoholOrIntoxicants: new FormControl('', [Validators.required]),
    alcoholOrIntoxicantsDescription: new FormControl('', [Validators.required]),
    helpForAlcoholAddiction: new FormControl('', [Validators.required]),
    helpForAlcoholAddictionDescription: new FormControl('', [Validators.required]),
    consumeCigarettes: new FormControl('', [Validators.required]),
    consumeCigarettesDescription: new FormControl('', [Validators.required]),
    seriousIllness: new FormControl('', [Validators.required]),
    seriousIllnessDescription: new FormControl('', [Validators.required]),
    dangerAtWork: new FormControl('', [Validators.required]),
    dangerAtWorkDescription: new FormControl('', [Validators.required]),
    tenYearMedicalTests: new FormControl('', [Validators.required]),
    tenYearmedicalTestsDescription: new FormControl('', [Validators.required]),
    thirtyDaysIncapable: new FormControl('', [Validators.required]),
    thirtyDaysIncapableDescription: new FormControl('', [Validators.required]),
    levelOfInvaliditet: new FormControl('', [Validators.required]),
    levelOfInvaliditetDescription: new FormControl('', [Validators.required]),
    newFifteenthQuestion: new FormControl('', [Validators.required]),
    newFifteenthQuestionDescription: new FormControl('', [Validators.required]),
    nameOfDoctor: new FormControl('', [Validators.required]),
    familySickness: new FormControl('', [Validators.required]),
    familySicknessDescription: new FormControl('', [Validators.required]),
    agreeToHealthQuestionnaire: new FormControl(true, [Validators.required])
  })

  // Forma za Obavestenje FATCA
  fatcaForm = new FormGroup({
    citizenshipSad: new FormControl('1', [Validators.required]),
    texpayerSad: new FormControl('1', [Validators.required]),
    insuredLegalEntitySad: new FormControl('1', [Validators.required]),
    insuredTaxpayerSad: new FormControl('1', [Validators.required]),
    insuredTenPrecentShare: new FormControl('1', [Validators.required]),
    insuredFinancialInstitution: new FormControl('1', [Validators.required])
  })

  // Forma za Obrazac SPNFT
  spnftForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    companyName: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    legalRepresentativeFirstname: new FormControl('', []),
    legalRepresentativeLastname: new FormControl('', []),
    representativeJmbg: new FormControl('', []),
    dob: new FormControl({ value: '', disabled: true }),
    settlementob: new FormControl('', [Validators.required]),
    pib: new FormControl('', []),
    mb: new FormControl('', []),
    address: new FormControl('', [Validators.required]),
    settlement: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    numberOfDocument: new FormControl('', [Validators.required]),
    typeOfDocument: new FormControl('', [Validators.required]),
    // dateOfIssuringDocument: new FormControl('', [Validators.required]),
    dateOfIssuringDocument: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    personalDocumentExpirationDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    placeOfIssuringDocument: new FormControl('', [Validators.required]),
    citizenship: new FormControl('', [Validators.required]),
    officialCloseFamily: new FormControl('0', []),
    closeFamilyName: new FormControl('', []),
    officialPeriod: new FormControl('', []),
    cutomerAnotherPerson: new FormControl('0', [Validators.required]),
    cutomerAnotherPersonRole: new FormControl('', [Validators.required]),
    firstnameOnBehalf: new FormControl('', [Validators.required]),
    lastnameOnBehalf: new FormControl('', [Validators.required]),
    dobOnBehalf: new FormControl({ value: '', disabled: true }),
    settlementobOnBehalf: new FormControl('', [Validators.required]),
    jmbgOnBehalf: new FormControl('', [Validators.required]),
    addressOnBehalf: new FormControl('', [Validators.required]),
    postalCodeOnBehalf: new FormControl('', [Validators.required]),
    settlementOnBehalf: new FormControl('', [Validators.required]),
    idNumberOnBehalf: new FormControl('', [Validators.required]),
    idTypeOnBehalf: new FormControl('', [Validators.required]),
    idDate: new FormControl('', [Validators.required, Validators.pattern('([0]{1}[1-9]{1}|[1-9]|[1-2]{1}[0-9]{1}|[3]{1}[0-1]{1})[\.]{1}([0]{1}[1-9]{1}|1|2|3|4|5|6|7|8|9|10|11|12)[\.]{1}[1-2]{1}[0-9]{3}')]),
    idPlace: new FormControl('', [Validators.required]),
    purposeOfBusinessRelation: new FormControl('', [Validators.required]),
    purposeOfBusinessRelationOther: new FormControl('', [Validators.required]),
    originOfProperty: new FormControl('', [Validators.required]),
    originOfPropertyOther: new FormControl('', [Validators.required])
  })

  // Forma za Obrazac PLATIMATIK
  platimatikForm = new FormGroup({
    firstname: new FormControl('', [Validators.required]),
    lastname: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required]),
    postalCode: new FormControl('', [Validators.required]),
    placeOfResidence: new FormControl('', [Validators.required]),
    jmbg: new FormControl('', [Validators.required]),
    firstThreeAccountNumber: new FormControl('', [Validators.required]),
    middleAccountNumber: new FormControl('', [Validators.required]),
    lastTwoAccountNumber: new FormControl('', [Validators.required]),
    bankName: new FormControl('', [Validators.required]),
    bankBic: new FormControl('', [Validators.required]),
    validityFirstTermFrom: new FormControl({ value: '', disabled: true }),
    validityFirstTermTo: new FormControl({ value: '', disabled: true }),
    validitySecondTermFrom: new FormControl({ value: '', disabled: true }),
    validitySecondTermTo: new FormControl({ value: '', disabled: true })
    // dateOfFirstObligationsDue: new FormControl('', []),
    // dateOfLastCommitment: new FormControl('', [])
  })

  // Forma za cekboksove na dnu
  checkBoxesForm = new FormGroup({
    confirmVeracity: new FormControl(false, []),
    confirmData: new FormControl(false, []),
    confirmSMS: new FormControl('1', []),
    confirmEmail: new FormControl('1', []),
    offer: new FormControl(true, []),
    redemptionAndCapitalization: new FormControl(true, []),
    proContract: new FormControl(true, []),
    terms: new FormControl(true, []),
    doctor: new FormControl(true, [])
  })

  riskAssessmentForm = new FormGroup({
    question1: new FormControl('', [Validators.required]),
    question2: new FormControl('', [Validators.required]),
    question3: new FormControl('', [Validators.required]),
    question4: new FormControl('', [Validators.required]),
    question5: new FormControl('', [Validators.required]),
    question6: new FormControl('', [Validators.required]),
    question7: new FormControl('', [Validators.required]),
    question8: new FormControl('', [Validators.required]),
    question9: new FormControl('', [Validators.required]),
    question10: new FormControl('', [Validators.required]),
    question11: new FormControl('', [Validators.required]),
    question12: new FormControl('', [Validators.required]),
    question13: new FormControl('', [Validators.required]),
    question14: new FormControl('', [Validators.required]),
    question15: new FormControl('', [Validators.required]),
    question16: new FormControl('', [Validators.required]),
    question17: new FormControl('', [Validators.required]),
    question18: new FormControl('', [Validators.required]),
    question19: new FormControl('', [Validators.required]),
    question20: new FormControl('', [Validators.required]),
    question21: new FormControl('', [Validators.required]),
    question22: new FormControl('', [Validators.required]),
    question23: new FormControl('', [Validators.required]),
    question24: new FormControl('', [Validators.required]),
    question25: new FormControl('', [Validators.required]),
    question26: new FormControl('', [Validators.required]),
    question27: new FormControl('', [Validators.required]),
    question28: new FormControl('', [Validators.required]),
    question29: new FormControl('', [Validators.required]),
    unableToGetData: new FormControl('')
  })

  standardMessageDoctor: string;
  basicInfo: BasicInformations
  sentInformations: any
  draftBool: boolean = true
  roleType: String = ''

  updateDraftModelFull: ProgressiveOffer


  constructor(
    private modalService: NgbModal,
    private router: Router,
    private basicInformationsService: BasicInformationsService,
    private saveDraftService: SaveDraftService,
    private editOfferService: EditOfferService,
    private fillDraftOfferService: FillDraftOfferService,
    private productRoleService: ProductRoleService,
    private bankService: BankService,
    private calculatorService: CalculatorService,
    private exportCalculatorService: ExportCalculatorService,
    private userService: UserService,
    private digitalService: DigitalService,
    private offerService: OfferService,
    private roleSendService: RoleSendService
  ) {
    if (this.todayDate.getDate() > 25) {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 2);
    } else {
      this.todayDate.setDate(1);
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    }

    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));

    this.basicInfoSubscription = basicInformationsService.info$.subscribe(
      (res: BasicInformations) => {
        // console.log(res);
        this.basicInfo = res;
      }
    )

    this.basicInfoSubscription = basicInformationsService.info$.subscribe(
      (res: BasicInformations) => {
        // console.log(res);
        this.basicInfo = res;
        if (res.data.contractorType == '1') {
          this.fatcaTypeBool = true;
          this.spnftForm.get('pib').setValue(res.data.contractorPIB);
          this.spnftForm.get('mb').setValue(res.data.contractorID);
          this.spnftForm.get('companyName').setValue(res.data.contractorResponsibleName);
        } else if (res.data.contractorType == '2') {
          this.fatcaTypeBool = false;
          this.spnftForm.get('pib').setValue('');
          this.spnftForm.get('mb').setValue('');
          this.spnftForm.get('companyName').setValue('');
        } else if (res.data.contractorType == '') {
          this.fatcaTypeBool = null;
        }

        // console.log(res.data)
        this.spnftForm.get('firstname').setValue(res.data.contractorFirstname);
        this.spnftForm.get('lastname').setValue(res.data.contractorLastname);
        this.spnftForm.get('jmbg').setValue(res.data.contractorJMBG);
        if (res.data.contractorJMBG) {
          if (res.data.contractorJMBG.length >= 7) {
            if (res.data.contractorJMBG.substring(4, 5) == '0') {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.2' + res.data.contractorJMBG.substring(4, 7))
            } else {
              this.spnftForm.get('dob').setValue(res.data.contractorJMBG.substring(0, 2) + "." + res.data.contractorJMBG.substring(2, 4) + '.1' + res.data.contractorJMBG.substring(4, 7))
            }
          }
        }
        // console.log(res.data.insuredJMBG)
        if (res.data.insuredJMBG) {
          if (res.data.insuredJMBG.length >= 7) {
            if (res.data.insuredJMBG.substring(4, 5) == '0') {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            } else {
              if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
                this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + res.data.insuredJMBG.substring(4, 7)))
                this.hideExport = false
              }
            }
          }
          // if (res.data.insuredJMBG.length >= 12) {
          //   if (parseInt(res.data.insuredJMBG.substring(9, 12)) < 500) {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'Ž') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('M')
          //       this.hideExport = false
          //     }
          //   } else {
          //     if (this.insuredSumAndPremiumForm.value.gender == 'M') {
          //       this.insuredSumAndPremiumForm.get('gender').setValue('Ž')
          //       this.hideExport = false
          //     }
          //   }
          // }
        }
        this.spnftForm.get('address').setValue(res.data.contractorAddress);
        this.spnftForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.spnftForm.get('settlement').setValue(res.data.contractorSettlement);

        this.platimatikForm.get('firstname').setValue(res.data.contractorFirstname);
        this.platimatikForm.get('lastname').setValue(res.data.contractorLastname);
        this.platimatikForm.get('placeOfResidence').setValue(res.data.contractorSettlement);
        this.platimatikForm.get('address').setValue(res.data.contractorAddress);
        this.platimatikForm.get('postalCode').setValue(res.data.contractorPostalCode);
        this.platimatikForm.get('jmbg').setValue(res.data.contractorJMBG)
      }
    )


    this.editSubscription = this.editOfferService.info$.subscribe(
      (res: Number) => {
        // console.log(res)
        if (res != 0) {
          this.draftBool = false;
          this.updateDraftModelFull = {
            Contractor: {},
            Insuree: {},
            Beneficiaries: [],
            HealthQuestionnaire: {},
            FATCAQuestionnaire: {},
            SPNFTForm: {},
            PlatimatikForm: {}
          }
          this.offerService.getOne(res)
            .then(
              (x: any) => {
                // console.log("EditSub")
                console.log(x);
                this.offerId = x.id;
                this.editOfferService.sendOfferID(0);
                this.getRoles(11);

                if (x.appointmentID)
                  this.updateDraftModelFull.AppointmentID = x.appointmentID;

                this.updateDraftModelFull.Contractor.ID = x.contractor.id;
                this.updateDraftModelFull.ContractorID = x.contractor.id;
                this.updateDraftModelFull.Insuree.ID = x.insuree.id;
                this.updateDraftModelFull.InsureeID = x.insuree.id;
                this.updateDraftModelFull.ID = x.id
                this.updateDraftModelFull.HealthQuestionnaire.OfferID = x.id
                this.updateDraftModelFull.FATCAQuestionnaire.OfferID = x.id
                this.updateDraftModelFull.SPNFTForm.OfferID = x.id
                this.updateDraftModelFull.PlatimatikForm.OfferID = x.id

                if (x.additionalPremiumRate == 0 || x.additionalPremiumRate == null) {
                  this.basicInfoForm.get('noSupplementaryInsurance').setValue(true)
                  this.supplementaryIsnuranceHideAllBool = true;
                }

                if (x.additionalInsuranceType == 0) {
                  this.supplementaryInsuranceBool = false
                  this.supplementaryIsnuranceHideAllBool = false
                  this.personalForm.get('deathByAccident').setValue(x.deathByAccident ? x.deathByAccident : '')
                  this.personalForm.get('invalidityByAccident').setValue(x.invalidityByAccident ? x.invalidityByAccident : '')
                  this.personalForm.get('surgery').setValue(x.surgery ? x.surgery : '')
                  this.personalForm.get('treatmanExpenses').setValue(x.treatmentExpenses ? x.treatmentExpenses : '')
                  this.personalForm.get('daylyFee').setValue(x.dailyFee ? x.dailyFee : '')
                  this.personalForm.get('monthlyRent').setValue(x.monthlyRent ? x.monthlyRent : '')
                  this.personalForm.get('includeDNA').setValue(x.includeDNA ? '1' : '0')
                  this.personalForm.get('includeMSO').setValue(x.includeMSO ? '1' : '0')


                  this.personalForm.get('riderDeath').setValue(x.additionalRiderDeath ? x.additionalRiderDeath : '')
                  this.personalForm.get('tbType').setValue(x.additionalRiderTBType ? x.additionalRiderTBType.toString() : '')
                  this.personalForm.get('riderTB').setValue(x.additionalRiderTB ? x.additionalRiderTB : '')
                  this.disabledPersonal();
                } else if (x.additionalInsuranceType == 5) {

                } else {
                  this.insuranceCoverageForm.get('incidentRadio').setValue(x.additionalInsuranceType.toString())
                }


                this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(x.insuranceStart, 'dd.MM.yyyy', 'en'))
                this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(x.insuranceEnd, 'dd.MM.yyyy', 'en'))
                this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(x.duration)
                this.insuredSumAndPremiumForm.get('accessAge').setValue(x.startingAge)
                this.insuredSumAndPremiumForm.get('dynamicsOfPayment').setValue(x.paymentFrequency)
                this.insuredSumAndPremiumForm.get('cigarettesDaily').setValue(x.cigarettesPerDay)
                this.insuredSumAndPremiumForm.get('height').setValue(x.height)
                this.insuredSumAndPremiumForm.get('weight').setValue(x.weight)
                this.insuredSumAndPremiumForm.get('currencyPayment').setValue(x.paymentInCurrency || x.paymentInCurrency == 0 ? x.paymentInCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('currencyPayout').setValue(x.paymentOutCurrency || x.paymentOutCurrency == 0 ? x.paymentOutCurrency.toString() : '')
                this.insuredSumAndPremiumForm.get('methodPayment').setValue(x.paymentType || x.paymentType == 0 ? x.paymentType.toString() : '')

                this.changeDate(null)

                this.basicInfoForm.get('premiumRate').setValue(x.premiumRate)
                this.basicInfoForm.get('insuranceSum').setValue(x.sumInsured)
                this.basicInfoForm.get('investingPack').setValue(x.selectedInvestmentPackage.toString())

                this.fillDraftOfferService.sendDraft({ contractor: x.contractor, insuree: x.insuree, contractorIsInsuree: x.contractorIsInsuree })

                this.insuranceUsers = [];
                if (x.beneficiaries.length > 0) {
                  for (let i = 0; i < x.beneficiaries.length; i++) {
                    let ob = {
                      OfferID: x.id,
                      Name: x.beneficiaries[i].name,
                      JMBG: x.beneficiaries[i].jmbg,
                      Description: x.beneficiaries[i].description,
                      RoleID: x.beneficiaries[i].roleID,
                      RoleName: x.beneficiaries[i].role.name
                    }
                    this.insuranceUsers.push(ob);
                  }
                }

                if (x.healthQuestionnaire) {
                  this.healthForm.get('threeMonthStayAbroad').setValue(x.healthQuestionnaire.q1Answer == null ? '' : x.healthQuestionnaire.q1Answer ? '0' : '1')
                  this.healthForm.get('threeMonthStayAbroadDescription').setValue(x.healthQuestionnaire.q1Description ? x.healthQuestionnaire.q1Description : '')
                  this.healthForm.get('deniedAcceptedRequest').setValue(x.healthQuestionnaire.q2Answer == null ? '' : x.healthQuestionnaire.q2Answer ? '0' : '1')
                  this.healthForm.get('deniedacceptedRequestDescription').setValue(x.healthQuestionnaire.q2Description ? x.healthQuestionnaire.q2Description : '')
                  this.healthForm.get('sportActivity').setValue(x.healthQuestionnaire.q3Answer == null ? '' : x.healthQuestionnaire.q3Answer ? '0' : '1')
                  this.healthForm.get('sportActivityDescription').setValue(x.healthQuestionnaire.q3Description ? x.healthQuestionnaire.q3Description : '')
                  this.healthForm.get('constantDoctorTreats').setValue(x.healthQuestionnaire.q4Answer == null ? '' : x.healthQuestionnaire.q4Answer ? '0' : '1')
                  this.healthForm.get('constantDoctorTreatsDescription').setValue(x.healthQuestionnaire.q4Description ? x.healthQuestionnaire.q4Description : '')
                  this.healthForm.get('specialMedicalExamination').setValue(x.healthQuestionnaire.q5Answer == null ? '' : x.healthQuestionnaire.q5Answer ? '0' : '1')
                  this.healthForm.get('specialMedicalExaminationDescription').setValue(x.healthQuestionnaire.q5Description ? x.healthQuestionnaire.q5Description : '')
                  this.healthForm.get('takingMedicines').setValue(x.healthQuestionnaire.q6Answer == null ? '' : x.healthQuestionnaire.q6Answer ? '0' : '1')
                  this.healthForm.get('takingMedicinesDescription').setValue(x.healthQuestionnaire.q6Description ? x.healthQuestionnaire.q6Description : '')
                  this.healthForm.get('alcoholOrIntoxicants').setValue(x.healthQuestionnaire.q7Answer == null ? '' : x.healthQuestionnaire.q7Answer ? '0' : '1')
                  this.healthForm.get('alcoholOrIntoxicantsDescription').setValue(x.healthQuestionnaire.q7Description ? x.healthQuestionnaire.q7Description : '')
                  this.healthForm.get('helpForAlcoholAddiction').setValue(x.healthQuestionnaire.q8Answer == null ? '' : x.healthQuestionnaire.q8Answer ? '0' : '1')
                  this.healthForm.get('helpForAlcoholAddictionDescription').setValue(x.healthQuestionnaire.q8Description ? x.healthQuestionnaire.q8Description : '')
                  this.healthForm.get('consumeCigarettes').setValue(x.healthQuestionnaire.q9Answer == null ? '' : x.healthQuestionnaire.q9Answer ? '0' : '1')
                  this.healthForm.get('consumeCigarettesDescription').setValue(x.healthQuestionnaire.q9Description ? x.healthQuestionnaire.q9Description : '')
                  this.healthForm.get('seriousIllness').setValue(x.healthQuestionnaire.q10Answer == null ? '' : x.healthQuestionnaire.q10Answer ? '0' : '1')
                  this.healthForm.get('seriousIllnessDescription').setValue(x.healthQuestionnaire.q10Description ? x.healthQuestionnaire.q10Description : '')
                  this.healthForm.get('dangerAtWork').setValue(x.healthQuestionnaire.q11Answer == null ? '' : x.healthQuestionnaire.q11Answer ? '0' : '1')
                  this.healthForm.get('dangerAtWorkDescription').setValue(x.healthQuestionnaire.q11Description ? x.healthQuestionnaire.q11Description : '')
                  this.healthForm.get('tenYearMedicalTests').setValue(x.healthQuestionnaire.q12Answer == null ? '' : x.healthQuestionnaire.q12Answer ? '0' : '1')
                  this.healthForm.get('tenYearmedicalTestsDescription').setValue(x.healthQuestionnaire.q12Description ? x.healthQuestionnaire.q12Description : '')
                  this.healthForm.get('thirtyDaysIncapable').setValue(x.healthQuestionnaire.q13Answer == null ? '' : x.healthQuestionnaire.q13Answer ? '0' : '1')
                  this.healthForm.get('thirtyDaysIncapableDescription').setValue(x.healthQuestionnaire.q13Description ? x.healthQuestionnaire.q13Description : '')
                  this.healthForm.get('levelOfInvaliditet').setValue(x.healthQuestionnaire.q14Answer == null ? '' : x.healthQuestionnaire.q14Answer ? '0' : '1')
                  this.healthForm.get('levelOfInvaliditetDescription').setValue(x.healthQuestionnaire.q14Description ? x.healthQuestionnaire.q14Description : '')

                  this.healthForm.get('newFifteenthQuestion').setValue(x.healthQuestionnaire.q15Answer == null ? '' : x.healthQuestionnaire.q15Answer ? '0' : '1')
                  this.healthForm.get('newFifteenthQuestionDescription').setValue(x.healthQuestionnaire.q15Description ? x.healthQuestionnaire.q15Description : '')

                  this.healthForm.get('nameOfDoctor').setValue(x.healthQuestionnaire.q16Answer ? x.healthQuestionnaire.q16Answer : '')
                  this.healthForm.get('familySickness').setValue(x.healthQuestionnaire.q17Answer == null ? '' : x.healthQuestionnaire.q17Answer ? '0' : '1')
                  this.healthForm.get('familySicknessDescription').setValue(x.healthQuestionnaire.q17Description ? x.healthQuestionnaire.q17Description : '')
                  this.healthForm.get('agreeToHealthQuestionnaire').setValue(x.healthQuestionnaire.agreement)
                }

                if (x.fatcaQuestionnaire) {
                  this.fatcaForm.get('citizenshipSad').setValue(x.fatcaQuestionnaire.q1NP ? '0' : '1')
                  this.fatcaForm.get('texpayerSad').setValue(x.fatcaQuestionnaire.q2NP ? '0' : '1')
                  this.fatcaForm.get('insuredLegalEntitySad').setValue(x.fatcaQuestionnaire.q1LE ? '0' : '1')
                  this.fatcaForm.get('insuredTaxpayerSad').setValue(x.fatcaQuestionnaire.q2LE ? '0' : '1')
                  this.fatcaForm.get('insuredTenPrecentShare').setValue(x.fatcaQuestionnaire.q3LE ? '0' : '1')
                  this.fatcaForm.get('insuredFinancialInstitution').setValue(x.fatcaQuestionnaire.q4LE ? '0' : '1')
                }

                if (x.spnftForm) {
                  this.spnftForm.get('firstname').setValue(x.spnftForm.firstname)
                  this.spnftForm.get('lastname').setValue(x.spnftForm.lastname)
                  this.spnftForm.get('companyName').setValue(x.spnftForm.companyName)
                  this.spnftForm.get('jmbg').setValue(x.spnftForm.jmbg)
                  if (x.spnftForm.jmbg) {
                    this.setSPNFTDate()
                  }
                  this.spnftForm.get('settlementob').setValue(x.spnftForm.placeOfBirth)
                  this.spnftForm.get('address').setValue(x.spnftForm.address)
                  this.spnftForm.get('postalCode').setValue(x.spnftForm.postalCode)
                  this.spnftForm.get('settlement').setValue(x.spnftForm.settlement)
                  this.spnftForm.get('citizenship').setValue(x.spnftForm.citizenship)
                  this.spnftForm.get('legalRepresentativeFirstname').setValue(x.spnftForm.legalRepresentativeFirtsname ? x.spnftForm.legalRepresentativeFirtsname : '')
                  this.spnftForm.get('legalRepresentativeLastname').setValue(x.spnftForm.legalRepresentativeLastname ? x.spnftForm.legalRepresentativeLastname : '')
                  this.spnftForm.get('representativeJmbg').setValue(x.spnftForm.legalRepresentativeJMBG ? x.spnftForm.legalRepresentativeJMBG : '')
                  this.spnftForm.get('pib').setValue(x.spnftForm.taxID ? x.spnftForm.taxID : '')
                  this.spnftForm.get('mb').setValue(x.spnftForm.companyID ? x.spnftForm.companyID : '')
                  this.spnftForm.get('numberOfDocument').setValue(x.spnftForm.personalDocumentNumber ? x.spnftForm.personalDocumentNumber : '')
                  this.spnftForm.get('typeOfDocument').setValue(x.spnftForm.personalDocumentType || x.spnftForm.personalDocumentType == 0 ? x.spnftForm.personalDocumentType.toString() : '')
                  this.spnftForm.get('dateOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedDate ? x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentIssuedDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('personalDocumentExpirationDate').setValue(x.spnftForm.personalDocumentExpirationDate ? x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[2] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[1] + "." + x.spnftForm.personalDocumentExpirationDate.split('T')[0].split('-')[0] : '')
                  this.spnftForm.get('placeOfIssuringDocument').setValue(x.spnftForm.personalDocumentIssuedPlace)

                  this.spnftForm.get('officialCloseFamily').setValue(x.spnftForm.isPoliticianOrCloseAssociate ? '1' : '0')
                  this.spnftForm.get('closeFamilyName').setValue(x.spnftForm.inOffice)
                  this.spnftForm.get('officialPeriod').setValue(x.spnftForm.remarkIfYes)

                  this.spnftForm.get('cutomerAnotherPerson').setValue(x.spnftForm.clientAppliesThroughIntermediary ? '1' : '0')
                  this.spnftForm.get('cutomerAnotherPersonRole').setValue(x.spnftForm.intermediaryType || x.spnftForm.intermediaryType == 0 ? x.spnftForm.intermediaryType.toString() : '')
                  this.spnftForm.get('firstnameOnBehalf').setValue(x.spnftForm.intermediaryFirstname)
                  this.spnftForm.get('lastnameOnBehalf').setValue(x.spnftForm.intermediaryLastname)
                  this.spnftForm.get('settlementobOnBehalf').setValue(x.spnftForm.intermediaryPlaceOfBirth)
                  this.spnftForm.get('jmbgOnBehalf').setValue(x.spnftForm.intermediaryJMBG)
                  // if (x.spnftForm.personalDocumentIssuedDate)
                  this.spnftForm.get('dobOnBehalf').setValue(x.spnftForm.intermediaryDateOfBirth ? formatDate(x.spnftForm.intermediaryDateOfBirth, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('addressOnBehalf').setValue(x.spnftForm.intermediaryAddress)
                  this.spnftForm.get('postalCodeOnBehalf').setValue(x.spnftForm.intermediaryPostalCode)
                  this.spnftForm.get('settlementOnBehalf').setValue(x.spnftForm.intermediarySettlement)
                  this.spnftForm.get('idNumberOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentNumber)
                  this.spnftForm.get('idTypeOnBehalf').setValue(x.spnftForm.intermediaryPersonalDocumentType || x.spnftForm.intermediaryPersonalDocumentType == 0 ? x.spnftForm.intermediaryPersonalDocumentType : '')
                  // if (x.spnftForm.intermediaryPersonalDocumentIssuedDate)
                  this.spnftForm.get('idDate').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedDate ? formatDate(x.spnftForm.intermediaryPersonalDocumentIssuedDate, 'dd.MM.yyyy', 'en') : '')
                  this.spnftForm.get('idPlace').setValue(x.spnftForm.intermediaryPersonalDocumentIssuedPlace)
                  if (x.spnftForm.businessRelationshipClientPurpose)
                    this.spnftForm.get('purposeOfBusinessRelation').setValue(x.spnftForm.businessRelationshipClientPurpose || x.spnftForm.businessRelationshipClientPurpose == 0 ? x.spnftForm.businessRelationshipClientPurpose.toString() : '')
                  this.spnftForm.get('purposeOfBusinessRelationOther').setValue(x.spnftForm.businessRelationshipClientPurposeOther)
                  this.spnftForm.get('originOfProperty').setValue(x.spnftForm.propertyOrigin || x.spnftForm.propertyOrigin == 0 ? x.spnftForm.propertyOrigin.toString() : '')
                  this.spnftForm.get('originOfPropertyOther').setValue(x.spnftForm.propertyOriginOther)
                }

                if (x.platimatikForm) {
                  this.platimatikForm.get('firstname').setValue(x.platimatikForm.firstname)
                  this.platimatikForm.get('lastname').setValue(x.platimatikForm.lastname)
                  this.platimatikForm.get('address').setValue(x.platimatikForm.address)
                  this.platimatikForm.get('postalCode').setValue(x.platimatikForm.postalCode)
                  this.platimatikForm.get('placeOfResidence').setValue(x.platimatikForm.settlement)
                  this.platimatikForm.get('jmbg').setValue(x.platimatikForm.jmbg)
                  this.platimatikForm.get('firstThreeAccountNumber').setValue(x.platimatikForm.accountNumber.substring(0, 3))
                  this.platimatikForm.get('middleAccountNumber').setValue(x.platimatikForm.accountNumber.substring(3, 16))
                  this.platimatikForm.get('lastTwoAccountNumber').setValue(x.platimatikForm.accountNumber.substring(16, 18))
                  this.platimatikForm.get('bankName').setValue(x.platimatikForm.bank)
                  this.platimatikForm.get('bankBic').setValue(x.platimatikForm.bic)
                  this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
                  this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
                }

                this.checkBoxesForm.get('confirmVeracity').setValue(x.verified)
                this.checkBoxesForm.get('confirmData').setValue(x.verified2)
                this.checkBoxesForm.get('confirmSMS').setValue(x.notificationsAgreement ? '1' : '0')
                this.checkBoxesForm.get('confirmEmail').setValue(x.verified3 ? '1' : '0')




              }
            )

        }
      }
    )


    // this.sumAndPremiumInfoSubscription = sendingSumAndPremiumInfo.info$.subscribe(
    //   (res: InsuranceSumAndPremium) => {
    //     // console.log(res);
    //     if (res.data.insuranceStart)
    //       this.insuredSumAndPremiumForm.get('insuranceStart').setValue(res.data.insuranceStart);
    //     if (res.data.insurancePeriod) {
    //       this.insuredSumAndPremiumForm.get('insurancePeriod').setValue(res.data.insurancePeriod);
    //       let tempYear = this.todayDate.getFullYear();
    //       let tempMonth = this.todayDate.getMonth();
    //       let tempDay = this.todayDate.getDate();
    //       let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
    //       this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));
    //       this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    //       this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    //     }
    //     if (res.data.accessAge)
    //       this.insuredSumAndPremiumForm.get('accessAge').setValue(res.data.accessAge);
    //     if (res.data.gender)
    //       this.insuredSumAndPremiumForm.get('gender').setValue(res.data.gender);
    //     // if (res.data.occupation)
    //     //   this.insuredSumAndPremiumForm.get('occupation').setValue(res.data.occupation);
    //     if (res.data.dynamicsOfPayment)
    //       this.insuredSumAndPremiumForm.get('dynamicsOfPayment').setValue(res.data.dynamicsOfPayment);
    //     if (res.data.cigarettesDaily)
    //       this.insuredSumAndPremiumForm.get('cigarettesDaily').setValue(res.data.cigarettesDaily);
    //     if (res.data.height)
    //       this.insuredSumAndPremiumForm.get('height').setValue(res.data.height);
    //     if (res.data.weight)
    //       this.insuredSumAndPremiumForm.get('weight').setValue(res.data.weight);
    //     if (res.data.currencyPayment)
    //       this.insuredSumAndPremiumForm.get('currencyPayment').setValue(res.data.currencyPayment);
    //     if (res.data.currencyPayout)
    //       this.insuredSumAndPremiumForm.get('currencyPayout').setValue(res.data.currencyPayout);
    //     if (res.data.indexation)
    //       this.insuredSumAndPremiumForm.get('indexation').setValue(res.data.indexation);
    //     if (res.data.methodPayment)
    //       this.insuredSumAndPremiumForm.get('methodPayment').setValue(res.data.methodPayment)
    //   }
    // )

  }

  ngOnInit() {
    this.getUser()
    this.getRoles(11)
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'));
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.roleService = this.roleSendService.info$.subscribe(
      (res: String) => {
        console.log(res)
        this.roleType = res;
      }
    )
  }

  ngOnDestroy(): void {
    this.basicInfoSubscription.unsubscribe()
    this.roleService.unsubscribe()
    this.editSubscription.unsubscribe()
  }

  insuredSumAndPremiumHide() {
    this.insuredSumANdPremimBool = !this.insuredSumANdPremimBool
  }
  basicInsuranceHide() {
    this.basicInsuranceBool = !this.basicInsuranceBool
  }
  basketViewHide() {
    this.basketViewBool = !this.basketViewBool
  }
  supplementaryInsuranceHide() {
    this.supplementaryInsuranceBool = !this.supplementaryInsuranceBool;
  }
  calculcatorUsersHide() {
    this.calculcatorUsersBool = !this.calculcatorUsersBool
  }
  healthQuestionnaireHide() {
    this.healthQuestionnaireBool = !this.healthQuestionnaireBool
  }
  noticePersonalityHide() {
    this.noticePersonalityBool = !this.noticePersonalityBool
  }
  noticeFatcaHide() {
    this.noticeFatcaBool = !this.noticeFatcaBool
  }
  formSpnftHide() {
    this.formSpnftBool = !this.formSpnftBool
  }
  formPlatimatikHide() {
    this.formPlatimatikBool = !this.formPlatimatikBool
  }

  changeDate(change: Boolean) {
    if (change == true) {
      this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    } else if (change == false) {
      this.todayDate.setMonth(this.todayDate.getMonth() - 1);
    }
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))

    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }

    console.log(this.insuredSumAndPremiumForm.value.insurancePeriod)
    if (this.insuredSumAndPremiumForm.value.insurancePeriod) {
      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));

      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    }
  }

  endingDateSet() {
    if (this.insuredSumAndPremiumForm.value.insurancePeriod) {
      let tempYear = this.todayDate.getFullYear();
      let tempMonth = this.todayDate.getMonth();
      let tempDay = this.todayDate.getDate();
      let tempDate = new Date(tempYear + this.insuredSumAndPremiumForm.value.insurancePeriod, tempMonth, tempDay);
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue(formatDate(tempDate, 'dd.MM.yyyy', 'en'));

      this.platimatikForm.get('validityFirstTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
      this.platimatikForm.get('validitySecondTermTo').setValue(formatDate(new Date(this.insuredSumAndPremiumForm.value.insurancePeriod + this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    } else {
      this.insuredSumAndPremiumForm.get('insuranceEnd').setValue('Trajanje osiguranja nije unet');
    }
    this.resetCalculation();
  }

  disabledPersonal() {
    if (this.personalForm.value.invalidityByAccident) {
      this.personalForm.controls['surgery'].enable();
      this.personalForm.controls['monthlyRent'].enable();
      this.personalForm.controls['treatmanExpenses'].enable();
      this.personalForm.controls['daylyFee'].enable();
      this.personalForm.controls['includeDNA'].enable();
      this.personalForm.controls['includeMSO'].enable();
    } else {
      this.personalForm.controls['surgery'].disable();
      this.personalForm.controls['monthlyRent'].disable();
      this.personalForm.controls['treatmanExpenses'].disable();
      this.personalForm.controls['daylyFee'].disable();
      this.personalForm.controls['includeDNA'].disable();
      this.personalForm.controls['includeMSO'].disable();
    }
  }

  addInsuranceUser() {
    let num = 0;
    for (let i = 0; i < this.insuranceUsers.length; i++) {
      if (parseInt(this.insuranceUserForm.value.role.split('-')[0]) == this.insuranceUsers[i].RoleID) {
        num++;
      }
    }
    if (parseInt(this.insuranceUserForm.value.role.split('-')[2]) == 0) {
      if (num >= 1) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    } else {
      if (num >= parseInt(this.insuranceUserForm.value.role.split('-')[2])) {
        this.errorTitle = "Ne mozete uneti više korisnika sa tom rolom";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        this.insuranceUsers.push(new Beneficiaries(0, this.insuranceUserForm.value.name.toUpperCase(), this.insuranceUserForm.value.jmbg, this.insuranceUserForm.value.remark, parseInt(this.insuranceUserForm.value.role.split('-')[0]), this.insuranceUserForm.value.role.split('-')[1], 0))
      }
    }
    this.insuranceUserForm.reset();
  }
  removeFromList(i) {
    this.insuranceUsers.splice(i, 1);
  }

  setSPNFTDate() {
    if (this.spnftForm.value.jmbg.length >= 7) {
      if (this.spnftForm.value.jmbg.substring(4, 5) == '0') {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.2' + this.spnftForm.value.jmbg.substring(4, 7))
      } else {
        this.spnftForm.get('dob').setValue(this.spnftForm.value.jmbg.substring(0, 2) + "." + this.spnftForm.value.jmbg.substring(2, 4) + '.1' + this.spnftForm.value.jmbg.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dob').setValue('')
    }
  }

  setdobOnBehalf() {
    if (this.spnftForm.value.jmbgOnBehalf.length >= 7) {
      if (this.spnftForm.value.jmbgOnBehalf.substring(4, 5) == '0') {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.2' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      } else {
        this.spnftForm.get('dobOnBehalf').setValue(this.spnftForm.value.jmbgOnBehalf.substring(0, 2) + "." + this.spnftForm.value.jmbgOnBehalf.substring(2, 4) + '.1' + this.spnftForm.value.jmbgOnBehalf.substring(4, 7))
      }
    } else {
      this.spnftForm.get('dobOnBehalf').setValue('')
    }
  }

  accountNumberSetBank() {
    if (this.platimatikForm.value.firstThreeAccountNumber.length == 3) {
      this.bankService.gridView(new Filter({ Top: null, Page: null, Filter: {}, Sort: {} }))
        .subscribe(
          (res: Array<{ code: String, name: String, swift: String }>) => {
            for (let i = 0; i < res.length; i++) {
              if (res[i].code == this.platimatikForm.value.firstThreeAccountNumber) {
                this.platimatikForm.get('bankName').setValue(res[i].name);
                this.platimatikForm.get('bankBic').setValue(res[i].swift);
                this.accNumber.nativeElement.focus();
                break;
              }
            }
          }
        )
    } else if (this.platimatikForm.value.firstThreeAccountNumber.length < 3) {
      this.platimatikForm.get('bankName').setValue('');
      this.platimatikForm.get('bankBic').setValue('');
    }
  }

  checkAccount() {
    if (this.platimatikForm.value.middleAccountNumber.length <= 13) {
      this.platimatikForm.get('middleAccountNumber').setValue('0'.repeat(13 - this.platimatikForm.value.middleAccountNumber.length) + this.platimatikForm.value.middleAccountNumber)
    }
  }

  noSupplementaryHide() {
    if (this.basicInfoForm.value.noSupplementaryInsurance) {
      this.supplementaryIsnuranceHideAllBool = true;
    } else {
      this.supplementaryIsnuranceHideAllBool = false;
    }
    this.resetCalculation()
  }

  sendInformations() {
    if (this.insuredSumAndPremiumForm.value.insurancePeriod && this.insuredSumAndPremiumForm.value.accessAge && this.insuredSumAndPremiumForm.value.dynamicsOfPayment && (this.insuredSumAndPremiumForm.value.cigarettesDaily || this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) && this.insuredSumAndPremiumForm.value.oneTimePayment && this.insuredSumAndPremiumForm.value.height && this.insuredSumAndPremiumForm.value.weight && this.basicInfoForm.value.premiumRate && this.basicInfoForm.value.insuranceSum && this.basicInfoForm.value.investingPack) {

      if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1' && this.basicInfoForm.value.premiumRate < (300 * Number(this.insuredSumAndPremiumForm.value.insurancePeriod))) {
        this.errorTitle = "Ukupna godišnja premija ne može biti manja od 300 EUR";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (((this.personalForm.value.tbType == '' && this.personalForm.value.riderTB > 0) || (this.personalForm.value.tbType != '' && (this.personalForm.value.riderTB == '' || this.personalForm.value.riderTB == 0 || this.personalForm.value.riderTB == null))) && !this.supplementaryIsnuranceHideAllBool && !this.supplementaryInsuranceBool) {
          this.errorTitle = "Niste uneli grupu težih bolesti ili niste odabrali iznos osigurane sume. Molimo Vas, proverite";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          let calculation: Progresive = {
            startTime: this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0],
            endTime: this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0],
            duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
            age: this.insuredSumAndPremiumForm.value.accessAge,
            gender: 'M',
            hazardLevel: 2,
            paymentFrequency: Number(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
            cigarettesPerDay: Number(this.insuredSumAndPremiumForm.value.cigarettesDaily),
            height: this.insuredSumAndPremiumForm.value.height,
            weight: this.insuredSumAndPremiumForm.value.weight,
            premiumRate: this.basicInfoForm.value.premiumRate,
            investmentPackage: Number(this.basicInfoForm.value.investingPack),
            guaranteedInsuredSum: this.basicInfoForm.value.insuranceSum,
            oneTimePayment: this.insuredSumAndPremiumForm.value.oneTimePayment == '0' ? false : true,
            investmentUnitStartPrice: 10,
            additionalInsurance: !this.supplementaryIsnuranceHideAllBool
          }

          if (!this.supplementaryInsuranceBool) {
            calculation.deathByAccident = this.personalForm.value.deathByAccident;

            calculation.riderDeath = this.personalForm.value.riderDeath ? this.personalForm.value.riderDeath : 0;
            calculation.tbType = this.personalForm.value.tbType != '' ? Number(this.personalForm.value.tbType) : 0;
            calculation.riderTB = this.personalForm.value.riderTB ? this.personalForm.value.riderTB : 0;

            if (this.personalForm.value.includeMSO == '0')
              calculation.includeMSO = false;
            else
              calculation.includeMSO = true;

            if (this.personalForm.value.includeDNA == '0')
              calculation.includeDNA = false;
            else
              calculation.includeDNA = true;

            calculation.selectedPackage = 0;

            if (this.personalForm.value.invalidityByAccident) {
              if (this.personalForm.value.surgery)
                calculation.surgery = this.personalForm.value.surgery;
              else
                calculation.surgery = 0;


              if (this.personalForm.value.monthlyRent)
                calculation.monthlyRent = this.personalForm.value.monthlyRent;
              else
                calculation.monthlyRent = 0;


              if (this.personalForm.value.daylyFee)
                calculation.dailyFee = this.personalForm.value.daylyFee;
              else
                calculation.dailyFee = 0

              if (this.personalForm.value.treatmanExpenses)
                calculation.treatmanExpenses = this.personalForm.value.treatmanExpenses;
              else
                calculation.treatmanExpenses = 0;

              calculation.invalidityByAccident = this.personalForm.value.invalidityByAccident;

            } else {
              calculation.invalidityByAccident = 0;
              calculation.surgery = 0;
              calculation.monthlyRent = 0;
              calculation.dailyFee = 0;
              calculation.treatmanExpenses = 0;
              calculation.includeMSO = false;
              calculation.includeDNA = false;
            }

          } else {
            calculation.deathByAccident = 0;
            calculation.invalidityByAccident = 0;
            calculation.surgery = 0;
            calculation.monthlyRent = 0;
            calculation.dailyFee = 0;
            calculation.treatmanExpenses = 0;

            calculation.riderDeath = 0;
            calculation.tbType = 0;
            calculation.riderTB = 0;

            calculation.includeMSO = false;
            calculation.includeDNA = false;
            calculation.selectedPackage = parseInt(this.insuranceCoverageForm.value.incidentRadio);
          }
          if (this.supplementaryIsnuranceHideAllBool) {
            calculation.selectedPackage = 0;
            calculation.deathByAccident = 0;
            calculation.invalidityByAccident = 0;
            calculation.surgery = 0;
            calculation.monthlyRent = 0;
            calculation.dailyFee = 0;
            calculation.treatmanExpenses = 0;

            calculation.riderDeath = 0;
            calculation.tbType = 0;
            calculation.riderTB = 0;

            calculation.includeMSO = false;
            calculation.includeDNA = false;
          }

          if (
            this.insuredSumAndPremiumForm.value.insurancePeriod < 10 ||
            this.insuredSumAndPremiumForm.value.insurancePeriod > 30 ||
            (this.insuredSumAndPremiumForm.value.insurancePeriod + this.insuredSumAndPremiumForm.value.accessAge) > 75 ||
            this.insuredSumAndPremiumForm.value.accessAge < 14 ||
            this.insuredSumAndPremiumForm.value.accessAge > 65 ||
            this.insuredSumAndPremiumForm.value.cigarettesDaily > 100
          ) {
            this.errorTitle = "Podaci nisu ispravni";
            this.modalService.open(this.alertModal, { centered: true })
            console.log("InValid")
          } else {
            if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              if (this.personalForm.value.deathByAccident) {
                if (
                  this.personalForm.value.deathByAccident > 100000 ||
                  (this.personalForm.value.surgery && (this.personalForm.value.surgery < 1000 || this.personalForm.value.surgery > 15000 || (this.personalForm.value.surgery > this.personalForm.value.deathByAccident * 2))) ||
                  (this.personalForm.value.invalidityByAccident && (this.personalForm.value.invalidityByAccident < this.personalForm.value.deathByAccident || this.personalForm.value.invalidityByAccident > this.personalForm.value.deathByAccident * 2)) ||
                  (this.personalForm.value.monthlyRent && (this.personalForm.value.monthlyRent < 100 || this.personalForm.value.monthlyRent > 600))
                ) {
                  this.errorTitle = "Podaci nisu ispravni";
                  this.modalService.open(this.alertModal, { centered: true })
                } else {
                  console.log(calculation);
                  this.basicInfoForm.get('yearlyPremium').setValue('')
                  this.basicInfoForm.get('increaseRatePremium').setValue('')
                  this.basicInfoForm.get('percentIUyearly').setValue('')
                  this.basicInfoForm.get('contractedPremium').setValue('')
                  this.basicInfoForm.get('ipValue').setValue('')

                  this.insuranceCoverageForm.get('deathByAccident').setValue('');
                  this.insuranceCoverageForm.get('disabilityByAccident').setValue('');
                  this.insuranceCoverageForm.get('surgery').setValue('');
                  this.insuranceCoverageForm.get('monthlyRent').setValue('');
                  this.insuranceCoverageForm.get('dailyFee').setValue('');
                  this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue('');
                  this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue('');
                  this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue('');
                  this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue('');
                  this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('');
                  this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue('');
                  this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('');
                  this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('');
                  this.insuranceCoverageForm.get('sumYearlyFirst').setValue('');
                  this.insuranceCoverageForm.get('sumYearlySecound').setValue('');
                  this.insuranceCoverageForm.get('sumYearlyThird').setValue('');
                  this.insuranceCoverageForm.get('sumYearlyForth').setValue('');

                  this.personalForm.get('additionalInsurance').setValue('');
                  this.personalForm.get('sumPremiumRateFirst').setValue('');
                  this.personalForm.get('sumYearlyFirst').setValue('');

                  this.calculatorService.calculateProgresive(calculation)
                    .then(
                      (x: any) => {
                        // console.log("personalizovano")
                        console.log(x)
                        this.hideExport = true
                        this.sentInformations = x

                        this.basicInfoForm.get('yearlyPremium').setValue(x.totalPremiumRateWithoutAdditionalYearly)
                        this.basicInfoForm.get('increaseRatePremium').setValue(x.riskPremiumIncreasement * 100)
                        this.basicInfoForm.get('percentIUyearly').setValue(x.investmentUnitYearlyValueChangePercentage * 100)
                        this.basicInfoForm.get('contractedPremium').setValue(x.totalPremium)
                        this.basicInfoForm.get('ipValue').setValue(x.ipEndValue.toFixed(2))

                        this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident);
                        this.insuranceCoverageForm.get('disabilityByAccident').setValue(x.invalidityByAccident);
                        this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                        this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                        this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent);

                        this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue(x.package1PremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue(x.package2PremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue(x.package3PremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue(x.package4PremiumRate.toFixed(2));

                        this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue(x.package2TotalPremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2));
                        this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2));

                        this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2));
                        this.insuranceCoverageForm.get('sumYearlySecound').setValue(x.package2TotalPremiumRateYearly.toFixed(2));
                        this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2));
                        this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2));

                        this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2));
                        this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2));
                        this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2));

                        // console.log(this.hideExport)
                        this.standardMessageDoctor = ""
                        if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                          //Standard program
                          switch (true) {
                            case (x.sumInsured <= 75000):
                              this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                              break;
                            case (x.sumInsured <= 100000):
                              this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                              break;
                            case (x.sumInsured <= 135000):
                              this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                              break;
                            case (x.sumInsured > 135000):
                              this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                              break;
                            default:
                              break;
                          }
                        } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                          //Standard program
                          switch (true) {
                            case (x.sumInsured <= 50000):
                              this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                              break;
                            case (x.sumInsured <= 75000):
                              this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                              break;
                            case (x.sumInsured <= 100000):
                              this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                              break;
                            case (x.sumInsured > 100000):
                              this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                              break;
                            default:
                              break;
                          }

                        } else {

                          //Standard program
                          switch (true) {
                            case (x.sumInsured <= 30000):
                              this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                              break;
                            case (x.sumInsured <= 50000):
                              this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                              break;
                            case (x.sumInsured <= 75000):
                              this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                              break;
                            case (x.sumInsured > 75000):
                              this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                              break;
                            default:
                              break;
                          }

                        }

                      }
                    )
                    .catch(
                      (e: { error: string }) => {
                        console.log(e)
                        this.errorTitle = e.error;
                        this.modalService.open(this.alertModal, { centered: true })
                      }
                    )
                }
              } else {
                this.errorTitle = "Niste uneli sve tražene podatke";
                this.modalService.open(this.alertModal, { centered: true })
              }
            } else {
              console.log(calculation);
              this.basicInfoForm.get('yearlyPremium').setValue('')
              this.basicInfoForm.get('increaseRatePremium').setValue('')
              this.basicInfoForm.get('percentIUyearly').setValue('')
              this.basicInfoForm.get('contractedPremium').setValue('')
              this.basicInfoForm.get('ipValue').setValue('')

              this.insuranceCoverageForm.get('deathByAccident').setValue('');
              this.insuranceCoverageForm.get('disabilityByAccident').setValue('');
              this.insuranceCoverageForm.get('surgery').setValue('');
              this.insuranceCoverageForm.get('monthlyRent').setValue('');
              this.insuranceCoverageForm.get('dailyFee').setValue('');
              this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue('');
              this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue('');
              this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue('');
              this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue('');
              this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue('');
              this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue('');
              this.insuranceCoverageForm.get('sumPremiumRateThird').setValue('');
              this.insuranceCoverageForm.get('sumPremiumRateForth').setValue('');
              this.insuranceCoverageForm.get('sumYearlyFirst').setValue('');
              this.insuranceCoverageForm.get('sumYearlySecound').setValue('');
              this.insuranceCoverageForm.get('sumYearlyThird').setValue('');
              this.insuranceCoverageForm.get('sumYearlyForth').setValue('');

              this.personalForm.get('additionalInsurance').setValue('');
              this.personalForm.get('sumPremiumRateFirst').setValue('');
              this.personalForm.get('sumYearlyFirst').setValue('');

              this.calculatorService.calculateProgresive(calculation)
                .then(
                  (x: any) => {
                    // console.log("dopunsko")
                    console.log(x)
                    this.hideExport = true
                    this.sentInformations = x

                    this.basicInfoForm.get('yearlyPremium').setValue(x.totalPremiumRateYearly)
                    this.basicInfoForm.get('increaseRatePremium').setValue(x.riskPremiumIncreasement * 100)
                    this.basicInfoForm.get('percentIUyearly').setValue(x.investmentUnitYearlyValueChangePercentage * 100)
                    this.basicInfoForm.get('contractedPremium').setValue(x.totalPremium)
                    this.basicInfoForm.get('ipValue').setValue(x.ipEndValue.toFixed(2))

                    this.insuranceCoverageForm.get('deathByAccident').setValue(x.deathByAccident);
                    this.insuranceCoverageForm.get('disabilityByAccident').setValue(x.invalidityByAccident);
                    this.insuranceCoverageForm.get('surgery').setValue(x.surgery);
                    this.insuranceCoverageForm.get('dailyFee').setValue(x.dailyFee);
                    this.insuranceCoverageForm.get('monthlyRent').setValue(x.monthlyRent);

                    this.insuranceCoverageForm.get('premiumRateSupplementaryFirst').setValue(x.package1PremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('premiumRateSupplementarySecound').setValue(x.package2PremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('premiumRateSupplementaryThird').setValue(x.package3PremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('premiumRateSupplementaryForth').setValue(x.package4PremiumRate.toFixed(2));

                    this.insuranceCoverageForm.get('sumPremiumRateFirst').setValue(x.package1TotalPremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('sumPremiumRateSecound').setValue(x.package2TotalPremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('sumPremiumRateThird').setValue(x.package3TotalPremiumRate.toFixed(2));
                    this.insuranceCoverageForm.get('sumPremiumRateForth').setValue(x.package4TotalPremiumRate.toFixed(2));

                    this.insuranceCoverageForm.get('sumYearlyFirst').setValue(x.package1TotalPremiumRateYearly.toFixed(2));
                    this.insuranceCoverageForm.get('sumYearlySecound').setValue(x.package2TotalPremiumRateYearly.toFixed(2));
                    this.insuranceCoverageForm.get('sumYearlyThird').setValue(x.package3TotalPremiumRateYearly.toFixed(2));
                    this.insuranceCoverageForm.get('sumYearlyForth').setValue(x.package4TotalPremiumRateYearly.toFixed(2));

                    this.personalForm.get('additionalInsurance').setValue(x.personalizedPremiumRate.toFixed(2));
                    this.personalForm.get('sumYearlyFirst').setValue(x.totalPremiumRateYearly.toFixed(2));
                    this.personalForm.get('sumPremiumRateFirst').setValue(x.totalPremiumRate.toFixed(2));

                    // console.log(this.hideExport)
                    this.standardMessageDoctor = ""
                    if (this.insuredSumAndPremiumForm.value.accessAge <= 45) {
                      //Standard program
                      switch (true) {
                        case (x.sumInsured <= 75000):
                          this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                          break;
                        case (x.sumInsured <= 100000):
                          this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                          break;
                        case (x.sumInsured <= 135000):
                          this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                          break;
                        case (x.sumInsured > 135000):
                          this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                          break;
                        default:
                          break;
                      }
                    } else if (this.insuredSumAndPremiumForm.value.accessAge >= 46 && this.insuredSumAndPremiumForm.value.accessAge <= 55) {

                      //Standard program
                      switch (true) {
                        case (x.sumInsured <= 50000):
                          this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                          break;
                        case (x.sumInsured <= 75000):
                          this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                          break;
                        case (x.sumInsured <= 100000):
                          this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                          break;
                        case (x.sumInsured > 100000):
                          this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                          break;
                        default:
                          break;
                      }

                    } else {

                      //Standard program
                      switch (true) {
                        case (x.sumInsured <= 30000):
                          this.standardMessageDoctor = 'Nije potrebno uraditi lekarski pregled.'
                          break;
                        case (x.sumInsured <= 50000):
                          this.standardMessageDoctor = 'Potrebno je uraditi mali lekarski pregled.'
                          break;
                        case (x.sumInsured <= 75000):
                          this.standardMessageDoctor = 'Potrebno je uraditi srednji lekarski pregled.'
                          break;
                        case (x.sumInsured > 75000):
                          this.standardMessageDoctor = 'Potrebno je uraditi veliki lekarski pregled.'
                          break;
                        default:
                          break;
                      }

                    }

                  }
                )
                .catch(
                  (e: { error: string }) => {
                    console.log(e)
                    this.errorTitle = e.error;
                    this.modalService.open(this.alertModal, { centered: true })
                  }
                )
            }
          }
        }
      }
    } else {
      this.errorTitle = "Niste uneli sve tražene podatke";
      this.modalService.open(this.alertModal, { centered: true })
    }

  }

  exportPdf() {
    let exportpdf: any = {
      ContratcorType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
      CompanyName: this.basicInfo.data.contractorResponsibleName,
      Firstname: this.basicInfo.data.contractorFirstname,
      Lastname: this.basicInfo.data.contractorLastname,
      JMBG: this.basicInfo.data.contractorJMBG,
      Email: this.basicInfo.data.contractorEmail,
      TaxID: this.basicInfo.data.contractorPIB,
      CompanyID: this.basicInfo.data.contractorID,
      Address: this.basicInfo.data.contractorAddress,
      Settlement: this.basicInfo.data.contractorSettlement,
      PostalCode: this.basicInfo.data.contractorPostalCode.toString(),
      ContactPhone: this.basicInfo.data.contractorPhonenumber,
      DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery,
      InsureeFirstname: this.basicInfo.data.insuredFirstname,
      InsureeLastname: this.basicInfo.data.insuredLastname,
      InsureeAddress: this.basicInfo.data.insuredAddress,
      InsureeSettlement: this.basicInfo.data.insuredSettlement,
      InsureePostalCode: this.basicInfo.data.insuredPostalCode.toString(),
      InsureeJMBG: this.basicInfo.data.insuredJMBG,
      InsureeContactPhone1: this.basicInfo.data.insuredMobile,
      InsureeContactPhone2: '',
      InsureeOccupation: this.basicInfo.data.insuredJob,
      StartTime: this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0],
      EndTime: this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0],
      Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
      Age: this.insuredSumAndPremiumForm.value.accessAge,
      Gender: 'M',
      HazardLevel: 2,
      CigarettesPerDay: this.insuredSumAndPremiumForm.value.cigarettesDaily,
      PaymentFrequency: parseInt(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      Height: this.insuredSumAndPremiumForm.value.height,
      Weight: this.insuredSumAndPremiumForm.value.weight,
      PremiumRate: this.basicInfoForm.value.premiumRate,
      Offer: this.checkBoxesForm.value.offer,
      OneTimePayment: this.insuredSumAndPremiumForm.value.oneTimePayment == '0' ? false : true,
      RedemptionAndCapitalization: this.checkBoxesForm.value.redemptionAndCapitalization,
      ProContract: this.checkBoxesForm.value.proContract,
      Terms: this.checkBoxesForm.value.terms,
      AdditionalInsurance: !this.supplementaryIsnuranceHideAllBool,
      AdditionalDocumentation: this.checkBoxesForm.value.doctor,
      InsureeDOB: this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : '',

      GuaranteedInsuredSum: this.basicInfoForm.value.insuranceSum,
      InvestmentPackage:
        this.basicInfoForm.value.investingPack == '0' ? 'Standardni' :
          this.basicInfoForm.value.investingPack == '1' ? 'Balansirani' :
            this.basicInfoForm.value.investingPack == '2' ? 'Fleksibilni' :
              this.basicInfoForm.value.investingPack == '3' ? 'Dinamički' : '',
      RiskPremiumIncreasement: this.sentInformations.riskPremiumIncreasement * 100,
      InvestmentUnitYearlyValueChangePercentage: this.sentInformations.investmentUnitYearlyValueChangePercentage * 100,
      IPEndValue: this.sentInformations.ipEndValue
    }

    if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      // console.log("Personal")
      exportpdf.DeathByAccident = this.personalForm.value.deathByAccident;
      exportpdf.SelectedPackage = 0;
      exportpdf.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;


      exportpdf.riderDeath = this.personalForm.value.riderDeath ? Number(this.personalForm.value.riderDeath) : 0;
      exportpdf.tbType = Number(this.personalForm.value.tbType);
      exportpdf.riderTB = this.personalForm.value.riderTB ? Number(this.personalForm.value.riderTB) : 0;

      if (this.personalForm.value.includeMSO == '0') {
        exportpdf.IncludeMSO = false;
      } else {
        exportpdf.IncludeMSO = true;
      }
      if (this.personalForm.value.includeDNA == '0') {
        exportpdf.IncludeDNA = false;
      } else {
        exportpdf.IncludeDNA = true;
      }
      if (this.personalForm.value.invalidityByAccident) {
        if (this.personalForm.value.surgery) {
          exportpdf.Surgery = this.personalForm.value.surgery;
        } else {
          exportpdf.Surgery = 0;
        }
        if (this.personalForm.value.monthlyRent) {
          exportpdf.MonthlyRent = this.personalForm.value.monthlyRent;
        } else {
          exportpdf.MonthlyRent = 0;
        }
        if (this.personalForm.value.daylyFee) {
          exportpdf.DailyFee = this.personalForm.value.daylyFee;
        } else {
          exportpdf.DailyFee = 0
        }
        if (this.personalForm.value.treatmanExpenses) {
          exportpdf.TreatmanExpenses = this.personalForm.value.treatmanExpenses;
        } else {
          exportpdf.TreatmanExpenses = 0;
        }
        exportpdf.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
      } else {
        exportpdf.InvalidityByAccident = 0;
        exportpdf.Surgery = 0;
        exportpdf.MonthlyRent = 0;
        exportpdf.DailyFee = 0;
        exportpdf.TreatmanExpenses = 0;
        exportpdf.IncludeMSO = false;
        exportpdf.IncludeDNA = false;
      }
      switch (this.personalForm.value.planRadio) {
        case '1':
          exportpdf.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        case '2':
          exportpdf.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        case '3':
          exportpdf.TotalPremiumRate = this.sentInformations.totalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
          break;
        default:
          break;
      }
    } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      console.log("Dopunsko")
      exportpdf.SelectedPackage = parseInt(this.insuranceCoverageForm.value.incidentRadio);
      exportpdf.DeathByAccident = this.sentInformations.deathByAccident;
      exportpdf.InvalidityByAccident = this.sentInformations.invalidityByAccident;
      exportpdf.MonthlyRent = this.sentInformations.monthlyRent;
      exportpdf.TreatmanExpenses = 0;
      exportpdf.DailyFee = 0;
      exportpdf.riderDeath = 0;
      exportpdf.tbType = 0;
      exportpdf.riderTB = 0;
      switch (this.insuranceCoverageForm.value.incidentRadio) {
        case '1':
          exportpdf.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
          exportpdf.TotalPremiumRate = this.sentInformations.package1TotalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.package1TotalPremiumRateYearly;
          exportpdf.Surgery = 0;
          exportpdf.IncludeMSO = false;
          exportpdf.IncludeDNA = false;
          break;
        case '2':
          exportpdf.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
          exportpdf.TotalPremiumRate = this.sentInformations.package2TotalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.package2TotalPremiumRateYearly;
          exportpdf.Surgery = this.sentInformations.surgery;
          exportpdf.IncludeMSO = true;
          exportpdf.IncludeDNA = false;
          break;
        case '3':
          exportpdf.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
          exportpdf.TotalPremiumRate = this.sentInformations.package3TotalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.package3TotalPremiumRateYearly;
          exportpdf.Surgery = this.sentInformations.surgery;
          exportpdf.DailyFee = this.sentInformations.dailyFee;
          exportpdf.IncludeMSO = false;
          exportpdf.IncludeDNA = false;
          break;
        case '4':
          exportpdf.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
          exportpdf.TotalPremiumRate = this.sentInformations.package4TotalPremiumRate;
          exportpdf.TotalPremiumRateYearly = this.sentInformations.package4TotalPremiumRateYearly;
          exportpdf.Surgery = 0;
          exportpdf.IncludeMSO = true;
          exportpdf.IncludeDNA = true;
          break;
        default:
          break;
      }
    } else {
      exportpdf.SelectedPackage = 0;
      exportpdf.DeathByAccident = 0;
      exportpdf.InvalidityByAccident = 0;
      exportpdf.Surgery = 0;
      exportpdf.TreatmanExpenses = 0;
      exportpdf.DailyFee = 0;
      exportpdf.MonthlyRent = 0;
      exportpdf.IncludeMSO = false;
      exportpdf.IncludeDNA = false;
      exportpdf.riderDeath = 0;
      exportpdf.tbType = 0;
      exportpdf.riderTB = 0;
      exportpdf.AdditionalPremiumRate = 0;
      exportpdf.TotalPremiumRate = this.sentInformations.totalPremiumRate;
      exportpdf.TotalPremiumRateYearly = this.sentInformations.totalPremiumRateYearly;
    }


    this.exportCalculatorService.exportProgressive(exportpdf)
      .then(
        x => {
          // console.log(x)
          let blob = new Blob([x.body], { type: 'application/octet-stream' });
          var contentDispositionHeader = x.headers.get('Content-Disposition');
          var filename = contentDispositionHeader.split(';')[1].trim().split('=')[1].split('"')[1];
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        }
      )
      .catch(
        e => console.log(e)
      )

  }

  draftModelFull: ProgressiveOffer;
  saveDraft() {
    this.draftModelFull = {
      OfferStatus: 0,
      RentPayment: 0,
      RentPaymentFrequency: 0,
      AdditionalInsuranceDeath: false,
      PaymentPeriodIn: 0,
      PaymentPeriodOut: 0,
      CreditAmount: 0,
      Interest: 0,
      PaymentPeriodMonths: 0,
      PaymentInCurrency: 0,
      PaymentOutCurrency: 0,
      AdditionalAS: false,
      AdditionalBF: false,
      AdditionalIL: false,

      ID: 0,
      OfferNumber: "",
      OfferType: 1,
      ProductType: 11,
      PaymentType: Number(this.insuredSumAndPremiumForm.value.methodPayment),
      ContractorID: 0,
      InsureeID: 0,
      UserID: this.userId,

      Contractor: {
        ID: 0,
        ClientType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
        Firstname: this.basicInfo.data.contractorFirstname,
        Lastname: this.basicInfo.data.contractorLastname,
        JMBG: this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : '',
        CompanyName: this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : '',
        TaxID: this.basicInfo.data.contractorType == '1' ? this.basicInfo.data.contractorPIB : '',
        CompanyID: this.basicInfo.data.contractorType == '1' ? this.basicInfo.data.contractorID : '',
        Mobile: this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : '',
        Email: this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : '',
        Address: this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : '',
        Settlement: this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : '',
        PostalCode: this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
        DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : '',
        DeliverySettlement: this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : '',
        DeliveryPostalCode: this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
        PhonebookID: 0
      },
      Insuree: {
        ID: 0,
        Firstname: this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : '',
        Lastname: this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : '',
        JMBG: this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : '',
        DOB: this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : '',
        Mobile: this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : '',
        Email: this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : '',
        Address: this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : '',
        Settlement: this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : '',
        PostalCode: this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
        Occupation: this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : '',
        PhonebookID: 0,
        ContractorID: 0
      },

      InsuranceStart: this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0],
      InsuranceEnd: this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0],
      StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
      Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
      Gender: "M",
      PaymentFrequency: Number(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      PaymentPeriod: 0,
      SelectedInvestmentPackage: Number(this.basicInfoForm.value.investingPack),
      OneTimePayment: false,
      CigarettesPerDay: Number(this.insuredSumAndPremiumForm.value.cigarettesDaily),
      Height: this.insuredSumAndPremiumForm.value.height,
      Weight: this.insuredSumAndPremiumForm.value.weight,
      HazardLevel: 2,
      ContractorIsInsuree: this.basicInfo.data.contractorCopy,

      PremiumRate: this.basicInfoForm.value.premiumRate,
      SumInsured: this.basicInfoForm.value.insuranceSum,
      Beneficiaries: this.insuranceUsers.length > 0 ? this.insuranceUsers : null,

      RiskPremiumIncreasement: this.sentInformations.riskPremiumIncreasement * 100,
      InvestmentUnitYearlyValueChangePercentage: this.sentInformations.investmentUnitYearlyValueChangePercentage * 100,
      IPEndValue: this.sentInformations.ipEndValue,

      HealthQuestionnaire: {
        OfferID: 0,
        Q1Answer: this.healthForm.value.threeMonthStayAbroad == '' ? null : this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
        Q1Description: this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
        Q2Answer: this.healthForm.value.deniedAcceptedRequest == '' ? null : this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
        Q2Description: this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
        Q3Answer: this.healthForm.value.sportActivity == '' ? null : this.healthForm.value.sportActivity == '0' ? true : false,
        Q3Description: this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
        Q4Answer: this.healthForm.value.constantDoctorTreats == '' ? null : this.healthForm.value.constantDoctorTreats == '0' ? true : false,
        Q4Description: this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
        Q5Answer: this.healthForm.value.specialMedicalExamination == '' ? null : this.healthForm.value.specialMedicalExamination == '0' ? true : false,
        Q5Description: this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
        Q6Answer: this.healthForm.value.takingMedicines == '' ? null : this.healthForm.value.takingMedicines == '0' ? true : false,
        Q6Description: this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
        Q7Answer: this.healthForm.value.alcoholOrIntoxicants == '' ? null : this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
        Q7Description: this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
        Q8Answer: this.healthForm.value.helpForAlcoholAddiction == '' ? null : this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
        Q8Description: this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
        Q9Answer: this.healthForm.value.consumeCigarettes == '' ? null : this.healthForm.value.consumeCigarettes == '0' ? true : false,
        Q9Description: this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
        Q10Answer: this.healthForm.value.seriousIllness == '' ? null : this.healthForm.value.seriousIllness == '0' ? true : false,
        Q10Description: this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
        Q11Answer: this.healthForm.value.dangerAtWork == '' ? null : this.healthForm.value.dangerAtWork == '0' ? true : false,
        Q11Description: this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
        Q12Answer: this.healthForm.value.tenYearMedicalTests == '' ? null : this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
        Q12Description: this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
        Q13Answer: this.healthForm.value.thirtyDaysIncapable == '' ? null : this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
        Q13Description: this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
        Q14Answer: this.healthForm.value.levelOfInvaliditet == '' ? null : this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
        Q14Description: this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
        Q15Answer: this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
        Q15Description: this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
        Q16Answer: this.healthForm.value.nameOfDoctor,
        Q17Answer: (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && this.healthForm.value.familySickness == '0') ? true : (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && this.healthForm.value.familySickness == '1') ? false : null,
        Q17Description: this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
        Agreement: this.healthForm.value.agreeToHealthQuestionnaire
      },

      FATCAQuestionnaire: {
        OfferID: 0,
        Q1NP: this.basicInfo.data.contractorType == '1' ? false : this.fatcaForm.value.citizenshipSad == '0' ? true : false,
        Q2NP: this.basicInfo.data.contractorType == '1' ? false : this.fatcaForm.value.texpayerSad == '0' ? true : false,
        Q1LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false : false,
        Q2LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false : false,
        Q3LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false : false,
        Q4LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false : false
      },

      SPNFTForm: {
        OfferID: 0,
        Firstname: this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
        Lastname: this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
        CompanyName: this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
        JMBG: this.spnftForm.value.jmbg ? this.spnftForm.value.jmbg : '',
        DateOfBirth: this.spnftForm.get('dob').value ? this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0] : '',
        PlaceOfBirth: this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
        Address: this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
        PostalCode: this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : '',
        Settlement: this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
        Citizenship: this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
        LegalRepresentativeFirtsname: this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
        LegalRepresentativeLastname: this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
        LegalRepresentativeJMBG: this.spnftForm.value.representativeJmbg ? this.spnftForm.value.representativeJmbg : '',
        TaxID: this.spnftForm.value.pib ? this.spnftForm.value.pib : '',
        CompanyID: this.spnftForm.value.mb ? this.spnftForm.value.mb : '',
        PersonalDocumentType: this.spnftForm.value.typeOfDocument ? this.spnftForm.value.typeOfDocument : '',
        PersonalDocumentNumber: this.spnftForm.value.numberOfDocument ? this.spnftForm.value.numberOfDocument : '',
        PersonalDocumentIssuedDate: this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
        PersonalDocumentExpirationDate: this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
        PersonalDocumentIssuedPlace: this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
        IsPoliticianOrCloseAssociate: this.spnftForm.value.officialCloseFamily == 0 ? false : true,
        InOffice: this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
        RemarkIfYes: this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
        ClientAppliesThroughIntermediary: !this.spnftForm.value.cutomerAnotherPerson ? false : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
        IntermediaryType: this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
        IntermediaryFirstname: this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
        IntermediaryLastname: this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
        IntermediaryJMBG: this.spnftForm.value.jmbgOnBehalf ? this.spnftForm.value.jmbgOnBehalf : '',
        IntermediaryDateOfBirth: this.spnftForm.get('dobOnBehalf').value ? this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0] : '',
        IntermediaryPlaceOfBirth: this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
        IntermediaryAddress: this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
        IntermediaryPostalCode: this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : '',
        IntermediarySettlement: this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
        IntermediaryPersonalDocumentType: this.spnftForm.value.idTypeOnBehalf ? this.spnftForm.value.idTypeOnBehalf : '',
        IntermediaryPersonalDocumentNumber: this.spnftForm.value.idNumberOnBehalf ? this.spnftForm.value.idNumberOnBehalf : '',
        IntermediaryPersonalDocumentIssuedDate: this.spnftForm.value.idDate ? this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0] : '',
        IntermediaryPersonalDocumentIssuedPlace: this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
        BusinessRelationshipClientPurpose: this.spnftForm.value.purposeOfBusinessRelation,
        BusinessRelationshipClientPurposeOther: this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
        PropertyOrigin: this.spnftForm.value.originOfProperty != '' ? this.spnftForm.value.originOfProperty : null,
        PropertyOriginOther: this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
      },

      PlatimatikForm: {
        OfferID: 0,
        Firstname: this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
        Lastname: this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
        Address: this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
        PostalCode: this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : '',
        Settlement: this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
        JMBG: this.platimatikForm.value.jmbg,
        Bank: this.platimatikForm.value.bankName,
        AccountNumber: this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
        BIC: this.platimatikForm.value.bankBic,
        ContractNumber: '',
        Currency: 1,
        FirstMandateFrom: this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
        FirstMandateTo: this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
        SecondMandateFrom: this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
        SecondMandateTo: this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
      },

      NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
      Verified: this.checkBoxesForm.value.confirmVeracity,
      Verified2: this.checkBoxesForm.value.confirmVeracity,
      Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false

    }

    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1') {
        this.errorTitle = "Ne možete kreirati draft ponudu ukoliko je izabrana jednokratna uplata";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
          this.saveDraftService.addInfo();
          console.log("Nije uneto ime i prezime")
        } else {
          if (
            ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
          ) {
            this.errorTitle = "Ne možete napraviti draft ponudu ukoliko godisnja premija nije manja od 1500 €";
            this.modalService.open(this.alertModal, { centered: true })
          } else {

            if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              // console.log("Personal")
              this.draftModelFull.AdditionalInsuranceType = 0;
              this.draftModelFull.DeathByAccident = this.personalForm.value.deathByAccident;
              this.draftModelFull.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;


              this.draftModelFull.AdditionalRiderDeath = this.personalForm.value.riderDeath;
              this.draftModelFull.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
              this.draftModelFull.AdditionalRiderTB = this.personalForm.value.riderTB;

              if (this.personalForm.value.includeMSO == '0') {
                this.draftModelFull.IncludeMSO = false;
              } else {
                this.draftModelFull.IncludeMSO = true;
              }
              if (this.personalForm.value.includeDNA == '0') {
                this.draftModelFull.IncludeDNA = false;
              } else {
                this.draftModelFull.IncludeDNA = true;
              }
              if (this.personalForm.value.invalidityByAccident) {
                if (this.personalForm.value.surgery) {
                  this.draftModelFull.Surgery = this.personalForm.value.surgery;
                } else {
                  this.draftModelFull.Surgery = null;
                }
                if (this.personalForm.value.monthlyRent) {
                  this.draftModelFull.MonthlyRent = this.personalForm.value.monthlyRent;
                } else {
                  this.draftModelFull.MonthlyRent = null;
                }
                if (this.personalForm.value.daylyFee) {
                  this.draftModelFull.DailyFee = this.personalForm.value.daylyFee;
                } else {
                  this.draftModelFull.DailyFee = null
                }
                if (this.personalForm.value.treatmanExpenses) {
                  this.draftModelFull.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
                } else {
                  this.draftModelFull.TreatmentExpenses = null;
                }
                this.draftModelFull.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
              } else {
                this.draftModelFull.InvalidityByAccident = null;
                this.draftModelFull.Surgery = null;
                this.draftModelFull.MonthlyRent = null;
                this.draftModelFull.DailyFee = null;
                this.draftModelFull.TreatmentExpenses = null;
                this.draftModelFull.IncludeMSO = false;
                this.draftModelFull.IncludeDNA = false;
              }

            } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              this.draftModelFull.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
              // console.log("Dopunsko")
              this.draftModelFull.DeathByAccident = this.sentInformations.deathByAccident;
              this.draftModelFull.InvalidityByAccident = this.sentInformations.invalidityByAccident;
              this.draftModelFull.MonthlyRent = this.sentInformations.monthlyRent;
              this.draftModelFull.TreatmentExpenses = null;
              this.draftModelFull.DailyFee = null;
              this.draftModelFull.AdditionalRiderDeath = null;
              this.draftModelFull.AdditionalRiderTBType = null;
              this.draftModelFull.AdditionalRiderTB = null;

              switch (this.insuranceCoverageForm.value.incidentRadio) {
                case '1':
                  this.draftModelFull.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                  this.draftModelFull.Surgery = null;
                  this.draftModelFull.IncludeMSO = false;
                  this.draftModelFull.IncludeDNA = false;
                  break;
                case '2':
                  this.draftModelFull.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                  this.draftModelFull.Surgery = this.sentInformations.surgery;
                  this.draftModelFull.IncludeMSO = true;
                  this.draftModelFull.IncludeDNA = false;
                  break;
                case '3':
                  this.draftModelFull.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                  this.draftModelFull.Surgery = this.sentInformations.surgery;
                  this.draftModelFull.DailyFee = this.sentInformations.dailyFee;
                  this.draftModelFull.IncludeMSO = false;
                  this.draftModelFull.IncludeDNA = false;
                  break;
                case '4':
                  this.draftModelFull.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                  this.draftModelFull.Surgery = null;
                  this.draftModelFull.IncludeMSO = true;
                  this.draftModelFull.IncludeDNA = true;
                  break;
                default:
                  break;
              }

            } else {
              this.draftModelFull.AdditionalInsuranceType = 5;
              this.draftModelFull.DeathByAccident = null;
              this.draftModelFull.InvalidityByAccident = null;
              this.draftModelFull.Surgery = null;
              this.draftModelFull.TreatmentExpenses = null;
              this.draftModelFull.DailyFee = null;
              this.draftModelFull.MonthlyRent = null;
              this.draftModelFull.IncludeMSO = false;
              this.draftModelFull.IncludeDNA = false;
              this.draftModelFull.AdditionalRiderDeath = null;
              this.draftModelFull.AdditionalRiderTBType = null;
              this.draftModelFull.AdditionalRiderTB = null;
              this.draftModelFull.AdditionalPremiumRate = 0;
            }

            this.offerService.createProgresivDraftOffer(this.draftModelFull)
              .then(
                x => {
                  this.successTitle = "Uspešno ste kreirali draft ponudu";
                  this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
                  this.resetEverything()
                  this.insuranceUsers = []
                  this.formPlatimatikBool = false;
                  this.formSpnftBool = false;
                  this.noticeFatcaBool = false;
                  this.healthQuestionnaireBool = false;
                  this.calculcatorUsersBool = false;
                  this.validInsuranceAndSumPremium = false;
                  this.validUser = false;
                  this.validSPNFT = false;
                  this.validPLATIMATIK = false;
                },
                e => console.log(e)
              )

          }
        }
      }
    }
  }

  updateDraft(draftTo: Number) {
    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {

      if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1') {
        this.errorTitle = "Ne možete kreirati draft ponudu ukoliko je izabrana jednokratna uplata";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname) {
          this.saveDraftService.addInfo();
          console.log("Nije uneto ime i prezime")
        } else {
          if (
            ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
          ) {
            this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
            this.modalService.open(this.alertModal, { centered: true })
          } else {

            this.updateDraftModelFull.OfferType = 1
            this.updateDraftModelFull.ProductType = 11
            this.updateDraftModelFull.OneTimePayment = false

            this.updateDraftModelFull.RentPayment = 0
            this.updateDraftModelFull.RentPaymentFrequency = 0
            this.updateDraftModelFull.AdditionalInsuranceDeath = false
            this.updateDraftModelFull.PaymentPeriodIn = 0
            this.updateDraftModelFull.PaymentPeriodOut = 0
            this.updateDraftModelFull.PaymentPeriodMonths = 0
            this.updateDraftModelFull.CreditAmount = 0
            this.updateDraftModelFull.Interest = 0
            this.updateDraftModelFull.PaymentPeriodMonths = 0
            this.updateDraftModelFull.AdditionalIL = false
            this.updateDraftModelFull.AdditionalBF = false
            this.updateDraftModelFull.AdditionalAS = false


            this.updateDraftModelFull.Contractor.ClientType = this.basicInfo.data.contractorType == '1' ? '1' : '0'
            this.updateDraftModelFull.Contractor.Firstname = this.basicInfo.data.contractorFirstname
            this.updateDraftModelFull.Contractor.Lastname = this.basicInfo.data.contractorLastname
            this.updateDraftModelFull.Contractor.CompanyName = this.basicInfo.data.contractorResponsibleName ? this.basicInfo.data.contractorResponsibleName : ''
            this.updateDraftModelFull.Contractor.JMBG = this.basicInfo.data.contractorJMBG ? this.basicInfo.data.contractorJMBG : ''
            this.updateDraftModelFull.Contractor.Mobile = this.basicInfo.data.contractorPhonenumber ? this.basicInfo.data.contractorPhonenumber : ''
            this.updateDraftModelFull.Contractor.Email = this.basicInfo.data.contractorEmail ? this.basicInfo.data.contractorEmail : ''
            this.updateDraftModelFull.Contractor.Address = this.basicInfo.data.contractorAddress ? this.basicInfo.data.contractorAddress : ''
            this.updateDraftModelFull.Contractor.Settlement = this.basicInfo.data.contractorSettlement ? this.basicInfo.data.contractorSettlement : ''
            this.updateDraftModelFull.Contractor.PostalCode = this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode : ''
            this.updateDraftModelFull.Contractor.DeliveryAddress = this.basicInfo.data.contractorAddressOfDelivery ? this.basicInfo.data.contractorAddressOfDelivery : ''
            this.updateDraftModelFull.Contractor.DeliverySettlement = this.basicInfo.data.contractorSettlementOfDelivery ? this.basicInfo.data.contractorSettlementOfDelivery : ''
            this.updateDraftModelFull.Contractor.DeliveryPostalCode = this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery : ''


            this.updateDraftModelFull.Insuree.Firstname = this.basicInfo.data.insuredFirstname ? this.basicInfo.data.insuredFirstname : ''
            this.updateDraftModelFull.Insuree.Lastname = this.basicInfo.data.insuredLastname ? this.basicInfo.data.insuredLastname : ''
            this.updateDraftModelFull.Insuree.JMBG = this.basicInfo.data.insuredJMBG ? this.basicInfo.data.insuredJMBG : ''
            this.updateDraftModelFull.Insuree.DOB = this.basicInfo.data.insuredDOB ? this.basicInfo.data.insuredDOB : ''
            this.updateDraftModelFull.Insuree.Mobile = this.basicInfo.data.insuredMobile ? this.basicInfo.data.insuredMobile : ''
            this.updateDraftModelFull.Insuree.Email = this.basicInfo.data.insuredEmail ? this.basicInfo.data.insuredEmail : ''
            this.updateDraftModelFull.Insuree.Address = this.basicInfo.data.insuredAddress ? this.basicInfo.data.insuredAddress : ''
            this.updateDraftModelFull.Insuree.Settlement = this.basicInfo.data.insuredSettlement ? this.basicInfo.data.insuredSettlement : ''
            this.updateDraftModelFull.Insuree.PostalCode = this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode : ''
            this.updateDraftModelFull.Insuree.Occupation = this.basicInfo.data.insuredJob ? this.basicInfo.data.insuredJob : ''

            this.updateDraftModelFull.InsuranceStart = this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0]
            this.updateDraftModelFull.InsuranceEnd = this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0]
            this.updateDraftModelFull.StartingAge = this.insuredSumAndPremiumForm.value.accessAge
            this.updateDraftModelFull.Duration = this.insuredSumAndPremiumForm.value.insurancePeriod
            this.updateDraftModelFull.Gender = "M"
            this.updateDraftModelFull.PaymentFrequency = Number(this.insuredSumAndPremiumForm.value.dynamicsOfPayment)
            this.updateDraftModelFull.PaymentPeriod = 0
            this.updateDraftModelFull.OneTimePayment = false
            this.updateDraftModelFull.CigarettesPerDay = this.insuredSumAndPremiumForm.value.cigarettesDaily
            this.updateDraftModelFull.Height = this.insuredSumAndPremiumForm.value.height
            this.updateDraftModelFull.Weight = this.insuredSumAndPremiumForm.value.weight
            this.updateDraftModelFull.HazardLevel = 2
            this.updateDraftModelFull.ContractorIsInsuree = this.basicInfo.data.contractorCopy

            this.updateDraftModelFull.PremiumRate = this.basicInfoForm.value.premiumRate
            this.updateDraftModelFull.SumInsured = this.basicInfoForm.value.insuranceSum
            this.updateDraftModelFull.SelectedInvestmentPackage = Number(this.basicInfoForm.value.investingPack)

            this.updateDraftModelFull.RiskPremiumIncreasement = this.sentInformations.riskPremiumIncreasement * 100
            this.updateDraftModelFull.InvestmentUnitYearlyValueChangePercentage = this.sentInformations.investmentUnitYearlyValueChangePercentage * 100
            this.updateDraftModelFull.IPEndValue = this.sentInformations.ipEndValue


            this.updateDraftModelFull.PaymentType = Number(this.insuredSumAndPremiumForm.value.methodPayment)
            this.updateDraftModelFull.PaymentInCurrency = Number(this.insuredSumAndPremiumForm.value.currencyPayment)
            this.updateDraftModelFull.PaymentOutCurrency = Number(this.insuredSumAndPremiumForm.value.currencyPayout)

            this.updateDraftModelFull.UserID = this.userId
            this.updateDraftModelFull.NotificationsAgreement = this.checkBoxesForm.value.confirmSMS == '1' ? true : false
            this.updateDraftModelFull.Verified = this.checkBoxesForm.value.confirmVeracity
            this.updateDraftModelFull.Verified2 = this.checkBoxesForm.value.confirmData
            this.updateDraftModelFull.Verified3 = this.checkBoxesForm.value.confirmEmail == '1' ? true : false


            if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              this.updateDraftModelFull.AdditionalInsuranceType = 0
              // console.log("Personal")
              this.updateDraftModelFull.DeathByAccident = this.personalForm.value.deathByAccident;
              this.updateDraftModelFull.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;

              this.updateDraftModelFull.AdditionalRiderDeath = this.personalForm.value.riderDeath;
              this.updateDraftModelFull.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
              this.updateDraftModelFull.AdditionalRiderTB = this.personalForm.value.riderTB;


              if (this.personalForm.value.includeMSO == '0') {
                this.updateDraftModelFull.IncludeMSO = false;
              } else {
                this.updateDraftModelFull.IncludeMSO = true;
              }
              if (this.personalForm.value.includeDNA == '0') {
                this.updateDraftModelFull.IncludeDNA = false;
              } else {
                this.updateDraftModelFull.IncludeDNA = true;
              }
              if (this.personalForm.value.invalidityByAccident) {
                if (this.personalForm.value.surgery) {
                  this.updateDraftModelFull.Surgery = this.personalForm.value.surgery;
                } else {
                  this.updateDraftModelFull.Surgery = null;
                }
                if (this.personalForm.value.monthlyRent) {
                  this.updateDraftModelFull.MonthlyRent = this.personalForm.value.monthlyRent;
                } else {
                  this.updateDraftModelFull.MonthlyRent = null;
                }
                if (this.personalForm.value.daylyFee) {
                  this.updateDraftModelFull.DailyFee = this.personalForm.value.daylyFee;
                } else {
                  this.updateDraftModelFull.DailyFee = null
                }
                if (this.personalForm.value.treatmanExpenses) {
                  this.updateDraftModelFull.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
                } else {
                  this.updateDraftModelFull.TreatmentExpenses = null;
                }
                this.updateDraftModelFull.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
              } else {
                this.updateDraftModelFull.InvalidityByAccident = null;
                this.updateDraftModelFull.Surgery = null;
                this.updateDraftModelFull.MonthlyRent = null;
                this.updateDraftModelFull.DailyFee = null;
                this.updateDraftModelFull.TreatmentExpenses = null;
                this.updateDraftModelFull.IncludeMSO = false;
                this.updateDraftModelFull.IncludeDNA = false;
              }
            } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              this.updateDraftModelFull.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
              // console.log("Dopunsko")
              this.updateDraftModelFull.DeathByAccident = this.sentInformations.deathByAccident;
              this.updateDraftModelFull.InvalidityByAccident = this.sentInformations.invalidityByAccident;
              this.updateDraftModelFull.MonthlyRent = this.sentInformations.monthlyRent;
              this.updateDraftModelFull.TreatmentExpenses = null;
              this.updateDraftModelFull.DailyFee = null;
              this.updateDraftModelFull.AdditionalRiderDeath = null;
              this.updateDraftModelFull.AdditionalRiderTBType = null;
              this.updateDraftModelFull.AdditionalRiderTB = null;

              switch (this.insuranceCoverageForm.value.incidentRadio) {
                case '1':
                  this.updateDraftModelFull.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                  this.updateDraftModelFull.Surgery = null;
                  this.updateDraftModelFull.IncludeMSO = false;
                  this.updateDraftModelFull.IncludeDNA = false;
                  break;
                case '2':
                  this.updateDraftModelFull.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                  this.updateDraftModelFull.Surgery = this.sentInformations.surgery;
                  this.updateDraftModelFull.IncludeMSO = true;
                  this.updateDraftModelFull.IncludeDNA = false;
                  break;
                case '3':
                  this.updateDraftModelFull.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                  this.updateDraftModelFull.Surgery = this.sentInformations.surgery;
                  this.updateDraftModelFull.DailyFee = this.sentInformations.dailyFee;
                  this.updateDraftModelFull.IncludeMSO = false;
                  this.updateDraftModelFull.IncludeDNA = false;
                  break;
                case '4':
                  this.updateDraftModelFull.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                  this.updateDraftModelFull.Surgery = null;
                  this.updateDraftModelFull.IncludeMSO = true;
                  this.updateDraftModelFull.IncludeDNA = true;
                  break;
                default:
                  break;
              }
            } else {
              this.updateDraftModelFull.AdditionalInsuranceType = 5
              this.updateDraftModelFull.DeathByAccident = null;
              this.updateDraftModelFull.InvalidityByAccident = null;
              this.updateDraftModelFull.Surgery = null;
              this.updateDraftModelFull.TreatmentExpenses = null;
              this.updateDraftModelFull.DailyFee = null;
              this.updateDraftModelFull.MonthlyRent = null;
              this.updateDraftModelFull.IncludeMSO = false;
              this.updateDraftModelFull.IncludeDNA = false;
              this.updateDraftModelFull.AdditionalRiderDeath = null;
              this.updateDraftModelFull.AdditionalRiderTBType = null;
              this.updateDraftModelFull.AdditionalRiderTB = null;
              this.updateDraftModelFull.AdditionalPremiumRate = 0;
            }


            if (this.insuranceUsers.length > 0)
              this.updateDraftModelFull.Beneficiaries = this.insuranceUsers

            if (this.healthForm.value.threeMonthStayAbroad != '')
              if (this.healthForm.value.threeMonthStayAbroad == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q1Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q1Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q1Description = this.healthForm.value.threeMonthStayAbroadDescription
            if (this.healthForm.value.deniedAcceptedRequest != '')
              if (this.healthForm.value.deniedAcceptedRequest == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q2Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q2Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q2Description = this.healthForm.value.deniedacceptedRequestDescription
            if (this.healthForm.value.sportActivity != '')
              if (this.healthForm.value.sportActivity == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q3Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q3Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q3Description = this.healthForm.value.sportActivityDescription
            if (this.healthForm.value.constantDoctorTreats != '')
              if (this.healthForm.value.constantDoctorTreats == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q4Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q4Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q4Description = this.healthForm.value.constantDoctorTreatsDescription
            if (this.healthForm.value.specialMedicalExamination != '')
              if (this.healthForm.value.specialMedicalExamination == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q5Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q5Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q5Description = this.healthForm.value.specialMedicalExaminationDescription
            if (this.healthForm.value.takingMedicines != '')
              if (this.healthForm.value.takingMedicines == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q6Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q6Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q6Description = this.healthForm.value.takingMedicinesDescription
            if (this.healthForm.value.alcoholOrIntoxicants != '')
              if (this.healthForm.value.alcoholOrIntoxicants == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q7Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q7Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q7Description = this.healthForm.value.alcoholOrIntoxicantsDescription
            if (this.healthForm.value.helpForAlcoholAddiction != '')
              if (this.healthForm.value.helpForAlcoholAddiction == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q8Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q8Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q8Description = this.healthForm.value.helpForAlcoholAddictionDescription
            if (this.healthForm.value.consumeCigarettes != '')
              if (this.healthForm.value.consumeCigarettes == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q9Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q9Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q9Description = this.healthForm.value.consumeCigarettesDescription
            if (this.healthForm.value.seriousIllness != '')
              if (this.healthForm.value.seriousIllness == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q10Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q10Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q10Description = this.healthForm.value.seriousIllnessDescription
            if (this.healthForm.value.dangerAtWork != '')
              if (this.healthForm.value.dangerAtWork == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q11Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q11Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q11Description = this.healthForm.value.dangerAtWorkDescription
            if (this.healthForm.value.tenYearMedicalTests != '')
              if (this.healthForm.value.tenYearMedicalTests == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q12Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q12Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q12Description = this.healthForm.value.tenYearmedicalTestsDescription
            if (this.healthForm.value.thirtyDaysIncapable != '')
              if (this.healthForm.value.thirtyDaysIncapable == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q13Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q13Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q13Description = this.healthForm.value.thirtyDaysIncapableDescription
            if (this.healthForm.value.levelOfInvaliditet != '')
              if (this.healthForm.value.levelOfInvaliditet == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q14Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q14Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q14Description = this.healthForm.value.levelOfInvaliditetDescription

            if (this.healthForm.value.newFifteenthQuestion != '')
              if (this.healthForm.value.newFifteenthQuestion == '0')
                this.updateDraftModelFull.HealthQuestionnaire.Q15Answer = true
              else
                this.updateDraftModelFull.HealthQuestionnaire.Q15Answer = false
            this.updateDraftModelFull.HealthQuestionnaire.Q15Description = this.healthForm.value.newFifteenthQuestionDescription

            this.updateDraftModelFull.HealthQuestionnaire.Q16Answer = this.healthForm.value.nameOfDoctor

            if (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              if (this.healthForm.value.familySickness == '0') {
                this.updateDraftModelFull.HealthQuestionnaire.Q17Answer = true
              } else {
                this.updateDraftModelFull.HealthQuestionnaire.Q17Answer = false
              }
            }
            this.updateDraftModelFull.HealthQuestionnaire.Q17Description = this.healthForm.value.familySicknessDescription

            this.updateDraftModelFull.HealthQuestionnaire.Agreement = this.healthForm.value.agreeToHealthQuestionnaire

            if (this.basicInfo.data.contractorType == '1') {
              this.updateDraftModelFull.FATCAQuestionnaire.Q1NP = false;
              this.updateDraftModelFull.FATCAQuestionnaire.Q2NP = false;
              this.updateDraftModelFull.FATCAQuestionnaire.Q1LE = this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false
              this.updateDraftModelFull.FATCAQuestionnaire.Q2LE = this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false
              this.updateDraftModelFull.FATCAQuestionnaire.Q3LE = this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false
              this.updateDraftModelFull.FATCAQuestionnaire.Q4LE = this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false
            } else {
              this.updateDraftModelFull.FATCAQuestionnaire.Q1NP = this.fatcaForm.value.citizenshipSad == '0' ? true : false
              this.updateDraftModelFull.FATCAQuestionnaire.Q2NP = this.fatcaForm.value.texpayerSad == '0' ? true : false
              this.updateDraftModelFull.FATCAQuestionnaire.Q1LE = false;
              this.updateDraftModelFull.FATCAQuestionnaire.Q2LE = false;
              this.updateDraftModelFull.FATCAQuestionnaire.Q3LE = false;
              this.updateDraftModelFull.FATCAQuestionnaire.Q4LE = false;
            }

            if (this.spnftForm.value.firstname)
              this.updateDraftModelFull.SPNFTForm.Firstname = this.spnftForm.value.firstname.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.Firstname = ''
            if (this.spnftForm.value.lastname)
              this.updateDraftModelFull.SPNFTForm.Lastname = this.spnftForm.value.lastname.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.Lastname = ''
            if (this.spnftForm.value.companyName)
              this.updateDraftModelFull.SPNFTForm.CompanyName = this.spnftForm.value.companyName.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.CompanyName = ''
            if (this.spnftForm.value.jmbg)
              this.updateDraftModelFull.SPNFTForm.JMBG = this.spnftForm.value.jmbg
            else
              this.updateDraftModelFull.SPNFTForm.JMBG = ''
            if (this.spnftForm.value.settlementob)
              this.updateDraftModelFull.SPNFTForm.PlaceOfBirth = this.spnftForm.value.settlementob.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.PlaceOfBirth = ''
            if (this.spnftForm.value.address)
              this.updateDraftModelFull.SPNFTForm.Address = this.spnftForm.value.address.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.Address = ''
            if (this.spnftForm.value.postalCode)
              this.updateDraftModelFull.SPNFTForm.PostalCode = this.spnftForm.value.postalCode
            else
              this.updateDraftModelFull.SPNFTForm.PostalCode = ''
            if (this.spnftForm.value.settlement)
              this.updateDraftModelFull.SPNFTForm.Settlement = this.spnftForm.value.settlement.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.Settlement = ''
            if (this.spnftForm.value.citizenship)
              this.updateDraftModelFull.SPNFTForm.Citizenship = this.spnftForm.value.citizenship.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.Citizenship = ''
            if (this.spnftForm.value.legalRepresentativeFirstname)
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeFirtsname = this.spnftForm.value.legalRepresentativeFirstname.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeFirtsname = ''
            if (this.spnftForm.value.legalRepresentativeLastname)
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeLastname = this.spnftForm.value.legalRepresentativeLastname.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeLastname = ''
            if (this.spnftForm.value.representativeJmbg)
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeJMBG = this.spnftForm.value.representativeJmbg
            else
              this.updateDraftModelFull.SPNFTForm.LegalRepresentativeJMBG = ''
            if (this.spnftForm.value.pib)
              this.updateDraftModelFull.SPNFTForm.TaxID = this.spnftForm.value.pib
            else
              this.updateDraftModelFull.SPNFTForm.TaxID = ''
            if (this.spnftForm.value.mb)
              this.updateDraftModelFull.SPNFTForm.CompanyID = this.spnftForm.value.mb
            else
              this.updateDraftModelFull.SPNFTForm.CompanyID = ''
            if (this.spnftForm.value.typeOfDocument)
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentType = this.spnftForm.value.typeOfDocument
            else
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentType = ''
            if (this.spnftForm.value.numberOfDocument)
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentNumber = this.spnftForm.value.numberOfDocument
            else
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentNumber = ''
            if (this.spnftForm.value.dateOfIssuringDocument)
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentIssuedDate = this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0]
            else
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentIssuedDate = ''
            if (this.spnftForm.value.personalDocumentExpirationDate)
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentExpirationDate = this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0]
            else
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentExpirationDate = ''
            if (this.spnftForm.value.placeOfIssuringDocument)
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentIssuedPlace = this.spnftForm.value.placeOfIssuringDocument.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.PersonalDocumentIssuedPlace = ''
            if (this.spnftForm.value.officialCloseFamily == 0)
              this.updateDraftModelFull.SPNFTForm.IsPoliticianOrCloseAssociate = false
            else
              this.updateDraftModelFull.SPNFTForm.IsPoliticianOrCloseAssociate = true
            if (this.spnftForm.value.officialCloseFamily == 1)
              this.updateDraftModelFull.SPNFTForm.InOffice = this.spnftForm.value.officialPeriod
            else
              this.updateDraftModelFull.SPNFTForm.InOffice = ''
            if (this.spnftForm.value.officialCloseFamily == 1)
              this.updateDraftModelFull.SPNFTForm.RemarkIfYes = this.spnftForm.value.closeFamilyName
            else
              this.updateDraftModelFull.SPNFTForm.RemarkIfYes = ''
            if (this.spnftForm.value.cutomerAnotherPerson == '')
              this.updateDraftModelFull.SPNFTForm.ClientAppliesThroughIntermediary = null
            else
              if (this.spnftForm.value.cutomerAnotherPerson == '1')
                this.updateDraftModelFull.SPNFTForm.ClientAppliesThroughIntermediary = true
              else
                this.updateDraftModelFull.SPNFTForm.ClientAppliesThroughIntermediary = false
            if (this.spnftForm.value.cutomerAnotherPersonRole)
              this.updateDraftModelFull.SPNFTForm.IntermediaryType = this.spnftForm.value.cutomerAnotherPersonRole
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryType = null
            if (this.spnftForm.value.firstnameOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryFirstname = this.spnftForm.value.firstnameOnBehalf.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryFirstname = ''
            if (this.spnftForm.value.lastnameOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryLastname = this.spnftForm.value.lastnameOnBehalf.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryLastname = ''
            if (this.spnftForm.value.jmbgOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryJMBG = this.spnftForm.value.jmbgOnBehalf
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryJMBG = ''
            if (this.spnftForm.get('dob').value)
              this.updateDraftModelFull.SPNFTForm.DateOfBirth = this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0]
            else
              this.updateDraftModelFull.SPNFTForm.DateOfBirth = ''
            if (this.spnftForm.get('dobOnBehalf').value)
              this.updateDraftModelFull.SPNFTForm.IntermediaryDateOfBirth = this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0]
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryDateOfBirth = ''
            if (this.spnftForm.value.settlementobOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPlaceOfBirth = this.spnftForm.value.settlementobOnBehalf.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPlaceOfBirth = ''
            if (this.spnftForm.value.addressOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryAddress = this.spnftForm.value.addressOnBehalf.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryAddress = ''
            if (this.spnftForm.value.postalCodeOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPostalCode = this.spnftForm.value.postalCodeOnBehalf
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPostalCode = ''
            if (this.spnftForm.value.settlementOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediarySettlement = this.spnftForm.value.settlementOnBehalf.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediarySettlement = ''
            if (this.spnftForm.value.idTypeOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentType = this.spnftForm.value.idTypeOnBehalf
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentType = ''
            if (this.spnftForm.value.idNumberOnBehalf)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentNumber = this.spnftForm.value.idNumberOnBehalf
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentNumber = ''
            if (this.spnftForm.value.idDate)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0]
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentIssuedDate = ''
            if (this.spnftForm.value.idPlace)
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = this.spnftForm.value.idPlace.toUpperCase()
            else
              this.updateDraftModelFull.SPNFTForm.IntermediaryPersonalDocumentIssuedPlace = ''
            if (this.spnftForm.value.purposeOfBusinessRelation != '')
              this.updateDraftModelFull.SPNFTForm.BusinessRelationshipClientPurpose = this.spnftForm.value.purposeOfBusinessRelation
            else
              this.updateDraftModelFull.SPNFTForm.BusinessRelationshipClientPurpose = null
            if (this.spnftForm.value.purposeOfBusinessRelation == '3')
              this.updateDraftModelFull.SPNFTForm.BusinessRelationshipClientPurposeOther = this.spnftForm.value.purposeOfBusinessRelationOther
            else
              this.updateDraftModelFull.SPNFTForm.BusinessRelationshipClientPurposeOther = ''
            if (this.spnftForm.value.originOfProperty != '')
              this.updateDraftModelFull.SPNFTForm.PropertyOrigin = this.spnftForm.value.originOfProperty
            else
              this.updateDraftModelFull.SPNFTForm.PropertyOrigin = null
            if (this.spnftForm.value.originOfProperty == '3')
              this.updateDraftModelFull.SPNFTForm.PropertyOriginOther = this.spnftForm.value.originOfPropertyOther
            else
              this.updateDraftModelFull.SPNFTForm.PropertyOriginOther = ''


            if (this.platimatikForm.value.firstname)
              this.updateDraftModelFull.PlatimatikForm.Firstname = this.platimatikForm.value.firstname.toUpperCase()
            else
              this.updateDraftModelFull.PlatimatikForm.Firstname = ''
            if (this.platimatikForm.value.lastname)
              this.updateDraftModelFull.PlatimatikForm.Lastname = this.platimatikForm.value.lastname.toUpperCase()
            else
              this.updateDraftModelFull.PlatimatikForm.Lastname = ''
            if (this.platimatikForm.value.address)
              this.updateDraftModelFull.PlatimatikForm.Address = this.platimatikForm.value.address.toUpperCase()
            else
              this.updateDraftModelFull.PlatimatikForm.Address = ''
            if (this.platimatikForm.value.postalCode)
              this.updateDraftModelFull.PlatimatikForm.PostalCode = this.platimatikForm.value.postalCode
            else
              this.updateDraftModelFull.PlatimatikForm.PostalCode = ''
            if (this.platimatikForm.value.placeOfResidence)
              this.updateDraftModelFull.PlatimatikForm.Settlement = this.platimatikForm.value.placeOfResidence.toUpperCase()
            else
              this.updateDraftModelFull.PlatimatikForm.Settlement = ''
            if (this.platimatikForm.value.jmbg)
              this.updateDraftModelFull.PlatimatikForm.JMBG = this.platimatikForm.value.jmbg
            else
              this.updateDraftModelFull.PlatimatikForm.JMBG = ''
            if (this.platimatikForm.value.bankName)
              this.updateDraftModelFull.PlatimatikForm.Bank = this.platimatikForm.value.bankName
            else
              this.updateDraftModelFull.PlatimatikForm.Bank = ''
            this.updateDraftModelFull.PlatimatikForm.AccountNumber = this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber
            if (this.platimatikForm.value.bankBic)
              this.updateDraftModelFull.PlatimatikForm.BIC = this.platimatikForm.value.bankBic
            else
              this.updateDraftModelFull.PlatimatikForm.BIC = ''
            this.updateDraftModelFull.PlatimatikForm.ContractNumber = ''
            this.updateDraftModelFull.PlatimatikForm.Currency = 1
            if (this.platimatikForm.get('validityFirstTermFrom').value)
              this.updateDraftModelFull.PlatimatikForm.FirstMandateFrom = this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0]
            else
              this.updateDraftModelFull.PlatimatikForm.FirstMandateFrom = ''
            if (this.platimatikForm.get('validityFirstTermTo').value)
              this.updateDraftModelFull.PlatimatikForm.FirstMandateTo = this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0]
            else
              this.updateDraftModelFull.PlatimatikForm.FirstMandateTo = ''
            if (this.platimatikForm.get('validitySecondTermFrom').value)
              this.updateDraftModelFull.PlatimatikForm.SecondMandateFrom = this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0]
            else
              this.updateDraftModelFull.PlatimatikForm.SecondMandateFrom = ''
            if (this.platimatikForm.get('validitySecondTermTo').value)
              this.updateDraftModelFull.PlatimatikForm.SecondMandateTo = this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0]
            else
              this.updateDraftModelFull.PlatimatikForm.SecondMandateTo = ''



            this.offerService.editProgressiveDraftOffer(this.updateDraftModelFull)
              .then(
                x => {
                  if (draftTo == 0) {
                    this.successTitle = "Uspešno ste sačuvali promene";
                    this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
                  } else if (draftTo == 1) {
                    this.offerService.createFromDraftOffer(this.offerId)
                      .then(
                        x => {
                          this.riskAssessmentForm.reset();
                          this.modalService.open(this.riskFormModal, { size: 'xl', backdrop: 'static', keyboard: false })
                          if (this.spnftForm.value.officialCloseFamily == '1') {
                            this.riskAssessmentForm.get('question11').setValue('0');
                            this.riskAssessmentForm.get('question11').disable();
                          } else {
                            this.riskAssessmentForm.get('question11').enable();
                          }
                        },
                        (x: any) => {
                          console.log(x)
                          this.errorTitle = x.error;
                          this.modalService.open(this.alertModal, { centered: true })
                        }
                      )
                  } else if (draftTo == 2) {
                    this.offerService.createFromDraftOffer(this.offerId)
                      .then(
                        x => {
                          this.offerService.sendLocalDocuments(this.offerId)
                            .then(
                              x => {
                                this.modalService.dismissAll();
                                this.resetEverything()
                                this.insuranceUsers = []
                                this.formPlatimatikBool = false;
                                this.formSpnftBool = false;
                                this.noticeFatcaBool = false;
                                this.healthQuestionnaireBool = false;
                                this.calculcatorUsersBool = false;
                                this.validInsuranceAndSumPremium = false;
                                this.validUser = false;
                                this.validSPNFT = false;
                                this.validPLATIMATIK = false;
                                this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                                // this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                              }
                            )
                        },
                        (x: any) => {
                          console.log(x)
                          this.errorTitle = x.error;
                          this.modalService.open(this.alertModal, { centered: true })
                        }
                      )
                  }

                },
                e => console.log(e)
              )
          }
        }
      }
    }
  }


  draftToDigital() {
    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }

    let helthBool = false;
    if (
      !this.healthForm.value.threeMonthStayAbroad ||
      (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
      !this.healthForm.value.deniedAcceptedRequest ||
      (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
      !this.healthForm.value.sportActivity ||
      (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
      !this.healthForm.value.constantDoctorTreats ||
      (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
      !this.healthForm.value.specialMedicalExamination ||
      (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
      !this.healthForm.value.takingMedicines ||
      (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
      !this.healthForm.value.alcoholOrIntoxicants ||
      (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
      !this.healthForm.value.helpForAlcoholAddiction ||
      (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
      !this.healthForm.value.consumeCigarettes ||
      (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
      !this.healthForm.value.seriousIllness ||
      (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
      !this.healthForm.value.dangerAtWork ||
      (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
      !this.healthForm.value.tenYearMedicalTests ||
      (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
      !this.healthForm.value.thirtyDaysIncapable ||
      (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
      !this.healthForm.value.levelOfInvaliditet ||
      (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
      !this.healthForm.value.newFifteenthQuestion ||
      (this.healthForm.value.newFifteenthQuestion == '0' && !this.healthForm.value.newFifteenthQuestionDescription) ||
      //
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && !this.healthForm.value.familySickness) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription)) ||

      !this.healthForm.value.nameOfDoctor ||
      !this.healthForm.value.agreeToHealthQuestionnaire
    ) {
      helthBool = true;
    } else {
      helthBool
    }

    if (
      (this.healthForm.value.consumeCigarettes == '0' && this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) ||
      (this.healthForm.value.consumeCigarettes == '1' && this.insuredSumAndPremiumForm.value.cigarettesDaily > 0)
    ) {
      this.errorTitle = "Odgovor na ponudi u vezi cigareta nije usklađen sa upitnikom. Molimo ispravite odgovor na ponudi.";
      this.modalService.open(this.alertModal, { centered: true })
      return;
    }

    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {

      if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1') {
        this.errorTitle = "Ne možete kreirati digitalnu ponudu ukoliko je izabrana jednokratna uplata";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (!this.userSignature) {
          this.errorTitle = "Nemate potpis";
          this.modalService.open(this.alertModal, { centered: true })
        } else {

          if (
            ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
          ) {
            this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
            this.modalService.open(this.alertModal, { centered: true })
          } else {

            let mobileRegex = new RegExp('0[0-9]{7,9}')
            let postalCodeRegex = new RegExp('[0-9]{5}')
            if (this.basicInfo.data.contractorType == '1') {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
                this.digitalService.addInfo(true);
              } else {
                console.log(this.basicInfo.data.insuredMobile)
                if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                  this.digitalService.addInfo(true);
                } else {
                  if (this.insuredSumAndPremiumForm.value.currencyPayment == '' || this.insuredSumAndPremiumForm.value.currencyPayout == '' || this.insuredSumAndPremiumForm.value.methodPayment == '') {
                    console.log(this.insuredSumAndPremiumForm.value.currencyPayment)
                    console.log(this.insuredSumAndPremiumForm.value.currencyPayout)
                    console.log(this.insuredSumAndPremiumForm.value.methodPayment)
                    this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.validInsuranceAndSumPremium = true;
                  } else {
                    if (this.userValue) {
                      this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.calculcatorUsersBool = true;
                      this.validUser = true
                    } else {
                      if (helthBool) {
                        this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.healthQuestionnaireBool = true;
                      } else {
                        if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                          this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.noticeFatcaBool = true;
                        } else {
                          if (
                            !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                            !this.spnftForm.value.jmbg ||
                            !this.spnftForm.value.settlementob ||
                            !this.spnftForm.value.address ||
                            !this.spnftForm.value.postalCode ||
                            !this.spnftForm.value.citizenship ||
                            !this.spnftForm.value.numberOfDocument ||
                            !this.spnftForm.value.typeOfDocument ||
                            !this.spnftForm.value.dateOfIssuringDocument ||
                            !this.spnftForm.value.personalDocumentExpirationDate ||
                            !this.spnftForm.value.placeOfIssuringDocument ||
                            !this.spnftForm.value.cutomerAnotherPerson ||
                            (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                            (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                            !this.spnftForm.value.purposeOfBusinessRelation ||
                            (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                            !this.spnftForm.value.originOfProperty ||
                            (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                          ) {
                            this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                            this.validSPNFT = true;
                            this.formSpnftBool = true;
                          } else {
                            if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                              if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                                this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                                this.validPLATIMATIK = true;
                                this.formPlatimatikBool = true
                              } else {
                                if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                  console.log("Mogu da se posalju podaci!")
                                  this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                                } else {
                                  this.errorTitle = "Morate da potvrdite saglasnost";
                                  this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                                }
                              }
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber))
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
                console.log("Prosle basic")
                console.log(this.basicInfo)
                this.digitalService.addInfo(true);
              } else {
                console.log(this.basicInfo.data.insuredMobile)
                if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                  console.log('prosole insured')
                  this.digitalService.addInfo(true);
                } else {
                  if (this.insuredSumAndPremiumForm.value.currencyPayment == '' || this.insuredSumAndPremiumForm.value.currencyPayout == '' || this.insuredSumAndPremiumForm.value.methodPayment == '') {
                    this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    console.log(this.insuredSumAndPremiumForm.value.currencyPayment)
                    console.log(this.insuredSumAndPremiumForm.value.currencyPayout)
                    console.log(this.insuredSumAndPremiumForm.value.methodPayment)
                    this.validInsuranceAndSumPremium = true;
                  } else {
                    console.log("Prosle currency")
                    if (this.userValue) {
                      this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.calculcatorUsersBool = true;
                      this.validUser = true
                    } else {
                      console.log("Prosli korisnici")
                      if (helthBool) {
                        this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.healthQuestionnaireBool = true;
                      } else {
                        console.log("Prosao zdravstveni")
                        if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                          this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.noticeFatcaBool = true;
                        } else {
                          if (
                            !this.spnftForm.value.firstname ||
                            !this.spnftForm.value.lastname ||
                            !this.spnftForm.value.jmbg ||
                            !this.spnftForm.value.settlementob ||
                            !this.spnftForm.value.address ||
                            !this.spnftForm.value.postalCode ||
                            !this.spnftForm.value.citizenship ||
                            !this.spnftForm.value.numberOfDocument ||
                            !this.spnftForm.value.typeOfDocument ||
                            !this.spnftForm.value.dateOfIssuringDocument ||
                            !this.spnftForm.value.personalDocumentExpirationDate ||
                            !this.spnftForm.value.placeOfIssuringDocument ||
                            !this.spnftForm.value.cutomerAnotherPerson ||
                            (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                            (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                            !this.spnftForm.value.purposeOfBusinessRelation ||
                            (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                            !this.spnftForm.value.originOfProperty ||
                            (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                          ) {
                            this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                            this.validSPNFT = true;
                            this.formSpnftBool = true;
                          } else {
                            console.log("Prosao spnft")
                            if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                              if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                                this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                                this.validPLATIMATIK = true;
                                this.formPlatimatikBool = true
                              } else {
                                console.log("Prosao platiomatik")
                                if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                  console.log("Mogu da se posalju podaci!")
                                  this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                                } else {
                                  this.errorTitle = "Morate da potvrdite saglasnost";
                                  this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                                }
                              }
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

        }

      }
    }


  }



  offerModelFull: ProgressiveOffer
  saveDigital() {
    this.userValue = true;
    loop1:
    for (let i = 0; i < this.roles.length; i++) {
      loop2:
      for (let j = 0; j < this.insuranceUsers.length; j++) {
        if (this.roles[i].productRoleID == this.insuranceUsers[j].RoleID) {
          this.userValue = false;
          break loop2;
        }
      }
      if (i + 1 == this.roles.length) {
        if (!this.userValue) {
          break loop1;
        }
      }
      if (!this.userValue) {
        this.userValue = true
      } else {
        break loop1;
      }
    }

    this.offerModelFull = {
      IdentificationFinished: false,
      RentPayment: 0,
      RentPaymentFrequency: 0,
      AdditionalInsuranceDeath: false,
      PaymentPeriodIn: 0,
      PaymentPeriodOut: 0,
      CreditAmount: 0,
      Interest: 0,
      PaymentPeriodMonths: 0,
      PaymentInCurrency: Number(this.insuredSumAndPremiumForm.value.currencyPayment),
      PaymentOutCurrency: Number(this.insuredSumAndPremiumForm.value.currencyPayout),
      AdditionalAS: false,
      AdditionalBF: false,
      AdditionalIL: false,
      SignedRemotely: false,
      OfferStatus: 0,

      ID: 0,
      OfferNumber: "",
      OfferType: 1,
      ProductType: 11,
      PaymentType: Number(this.insuredSumAndPremiumForm.value.methodPayment),
      ContractorID: 0,
      InsureeID: 0,
      Contractor: {
        ID: 0,
        ClientType: this.basicInfo.data.contractorType == '1' ? '1' : '0',
        Firstname: this.basicInfo.data.contractorFirstname,
        Lastname: this.basicInfo.data.contractorLastname,
        JMBG: this.basicInfo.data.contractorJMBG,
        CompanyName: this.basicInfo.data.contractorResponsibleName,
        TaxID: this.basicInfo.data.contractorType == '1' ? this.basicInfo.data.contractorPIB : '',
        CompanyID: this.basicInfo.data.contractorType == '1' ? this.basicInfo.data.contractorID : '',
        Mobile: this.basicInfo.data.contractorPhonenumber,
        Email: this.basicInfo.data.contractorEmail,
        Address: this.basicInfo.data.contractorAddress,
        Settlement: this.basicInfo.data.contractorSettlement,
        PostalCode: this.basicInfo.data.contractorPostalCode ? this.basicInfo.data.contractorPostalCode.toString() : "",
        DeliveryAddress: this.basicInfo.data.contractorAddressOfDelivery,
        DeliverySettlement: this.basicInfo.data.contractorSettlementOfDelivery,
        DeliveryPostalCode: this.basicInfo.data.contractorPostalCodeOfDelivery ? this.basicInfo.data.contractorPostalCodeOfDelivery.toString() : "",
        PhonebookID: 0
      },
      Insuree: {
        ID: 0,
        Firstname: this.basicInfo.data.insuredFirstname,
        Lastname: this.basicInfo.data.insuredLastname,
        JMBG: this.basicInfo.data.insuredJMBG,
        DOB: this.basicInfo.data.insuredDOB,
        Mobile: this.basicInfo.data.insuredMobile,
        Email: this.basicInfo.data.insuredEmail,
        Address: this.basicInfo.data.insuredAddress,
        Settlement: this.basicInfo.data.insuredSettlement,
        PostalCode: this.basicInfo.data.insuredPostalCode ? this.basicInfo.data.insuredPostalCode.toString() : "",
        Occupation: this.basicInfo.data.insuredJob,
        PhonebookID: 0,
        ContractorID: 0
      },

      ContractorIsInsuree: this.basicInfo.data.contractorCopy,
      HazardLevel: 2,

      InsuranceStart: this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[0],
      InsuranceEnd: this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[2] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[1] + '-' + this.insuredSumAndPremiumForm.get('insuranceEnd').value.split('.')[0],
      StartingAge: this.insuredSumAndPremiumForm.value.accessAge,
      Duration: this.insuredSumAndPremiumForm.value.insurancePeriod,
      Gender: 'M',
      PaymentFrequency: Number(this.insuredSumAndPremiumForm.value.dynamicsOfPayment),
      PaymentPeriod: 0,
      SelectedInvestmentPackage: Number(this.basicInfoForm.value.investingPack),
      OneTimePayment: false,
      CigarettesPerDay: Number(this.insuredSumAndPremiumForm.value.cigarettesDaily),
      Height: this.insuredSumAndPremiumForm.value.height,
      Weight: this.insuredSumAndPremiumForm.value.weight,

      PremiumRate: this.basicInfoForm.value.premiumRate,
      SumInsured: this.basicInfoForm.value.insuranceSum,
      Beneficiaries: this.insuranceUsers,

      RiskPremiumIncreasement: this.sentInformations.riskPremiumIncreasement * 100,
      InvestmentUnitYearlyValueChangePercentage: this.sentInformations.investmentUnitYearlyValueChangePercentage * 100,
      IPEndValue: this.sentInformations.ipEndValue,

      HealthQuestionnaire: {
        OfferID: 0,
        Q1Answer: this.healthForm.value.threeMonthStayAbroad == '0' ? true : false,
        Q1Description: this.healthForm.value.threeMonthStayAbroad == '0' ? this.healthForm.value.threeMonthStayAbroadDescription : '',
        Q2Answer: this.healthForm.value.deniedAcceptedRequest == '0' ? true : false,
        Q2Description: this.healthForm.value.deniedAcceptedRequest == '0' ? this.healthForm.value.deniedacceptedRequestDescription : '',
        Q3Answer: this.healthForm.value.sportActivity == '0' ? true : false,
        Q3Description: this.healthForm.value.sportActivity == '0' ? this.healthForm.value.sportActivityDescription : '',
        Q4Answer: this.healthForm.value.constantDoctorTreats == '0' ? true : false,
        Q4Description: this.healthForm.value.constantDoctorTreats == '0' ? this.healthForm.value.constantDoctorTreatsDescription : '',
        Q5Answer: this.healthForm.value.specialMedicalExamination == '0' ? true : false,
        Q5Description: this.healthForm.value.specialMedicalExamination == '0' ? this.healthForm.value.specialMedicalExaminationDescription : '',
        Q6Answer: this.healthForm.value.takingMedicines == '0' ? true : false,
        Q6Description: this.healthForm.value.takingMedicines == '0' ? this.healthForm.value.takingMedicinesDescription : '',
        Q7Answer: this.healthForm.value.alcoholOrIntoxicants == '0' ? true : false,
        Q7Description: this.healthForm.value.alcoholOrIntoxicants == '0' ? this.healthForm.value.alcoholOrIntoxicantsDescription : '',
        Q8Answer: this.healthForm.value.helpForAlcoholAddiction == '0' ? true : false,
        Q8Description: this.healthForm.value.helpForAlcoholAddiction == '0' ? this.healthForm.value.helpForAlcoholAddictionDescription : '',
        Q9Answer: this.healthForm.value.consumeCigarettes == '0' ? true : false,
        Q9Description: this.healthForm.value.consumeCigarettes == '0' ? this.healthForm.value.consumeCigarettesDescription : '',
        Q10Answer: this.healthForm.value.seriousIllness == '0' ? true : false,
        Q10Description: this.healthForm.value.seriousIllness == '0' ? this.healthForm.value.seriousIllnessDescription : '',
        Q11Answer: this.healthForm.value.dangerAtWork == '0' ? true : false,
        Q11Description: this.healthForm.value.dangerAtWork == '0' ? this.healthForm.value.dangerAtWorkDescription : '',
        Q12Answer: this.healthForm.value.tenYearMedicalTests == '0' ? true : false,
        Q12Description: this.healthForm.value.tenYearMedicalTests == '0' ? this.healthForm.value.tenYearmedicalTestsDescription : '',
        Q13Answer: this.healthForm.value.thirtyDaysIncapable == '0' ? true : false,
        Q13Description: this.healthForm.value.thirtyDaysIncapable == '0' ? this.healthForm.value.thirtyDaysIncapableDescription : '',
        Q14Answer: this.healthForm.value.levelOfInvaliditet == '0' ? true : false,
        Q14Description: this.healthForm.value.levelOfInvaliditet == '0' ? this.healthForm.value.levelOfInvaliditetDescription : '',
        Q15Answer: this.healthForm.value.newFifteenthQuestion == '0' ? true : this.healthForm.value.newFifteenthQuestion == '1' ? false : null,
        Q15Description: this.healthForm.value.newFifteenthQuestion == '0' ? this.healthForm.value.newFifteenthQuestionDescription : '',
        Q16Answer: this.healthForm.value.nameOfDoctor,
        Q17Answer: (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool && this.healthForm.value.familySickness == '0') ? true : (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && this.healthForm.value.familySickness == '1') ? false : null,
        Q17Description: this.healthForm.value.familySickness == '0' ? this.healthForm.value.familySicknessDescription : '',
        Agreement: this.healthForm.value.agreeToHealthQuestionnaire
      },
      FATCAQuestionnaire: {
        OfferID: 0,
        Q1NP: this.basicInfo.data.contractorType == '1' ? false : this.fatcaForm.value.citizenshipSad == '0' ? true : false,
        Q2NP: this.basicInfo.data.contractorType == '1' ? false : this.fatcaForm.value.texpayerSad == '0' ? true : false,
        Q1LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredLegalEntitySad == '0' ? true : false : false,
        Q2LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredTaxpayerSad == '0' ? true : false : false,
        Q3LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredTenPrecentShare == '0' ? true : false : false,
        Q4LE: this.basicInfo.data.contractorType == '1' ? this.fatcaForm.value.insuredFinancialInstitution == '0' ? true : false : false
      },
      SPNFTForm: {
        OfferID: 0,
        Firstname: this.spnftForm.value.firstname ? this.spnftForm.value.firstname.toUpperCase() : '',
        Lastname: this.spnftForm.value.lastname ? this.spnftForm.value.lastname.toUpperCase() : '',
        CompanyName: this.spnftForm.value.companyName ? this.spnftForm.value.companyName.toUpperCase() : '',
        JMBG: this.spnftForm.value.jmbg,
        DateOfBirth: this.spnftForm.get('dob').value ? this.spnftForm.get('dob').value.split('.')[2] + '-' + this.spnftForm.get('dob').value.split('.')[1] + '-' + this.spnftForm.get('dob').value.split('.')[0] : '',
        PlaceOfBirth: this.spnftForm.value.settlementob ? this.spnftForm.value.settlementob.toUpperCase() : '',
        Address: this.spnftForm.value.address ? this.spnftForm.value.address.toUpperCase() : '',
        PostalCode: this.spnftForm.value.postalCode ? this.spnftForm.value.postalCode.toString() : '',
        Settlement: this.spnftForm.value.settlement ? this.spnftForm.value.settlement.toUpperCase() : '',
        Citizenship: this.spnftForm.value.citizenship ? this.spnftForm.value.citizenship.toUpperCase() : '',
        LegalRepresentativeFirtsname: this.spnftForm.value.legalRepresentativeFirstname ? this.spnftForm.value.legalRepresentativeFirstname.toUpperCase() : '',
        LegalRepresentativeLastname: this.spnftForm.value.legalRepresentativeLastname ? this.spnftForm.value.legalRepresentativeLastname.toUpperCase() : '',
        LegalRepresentativeJMBG: this.spnftForm.value.representativeJmbg,
        TaxID: this.spnftForm.value.pib,
        CompanyID: this.spnftForm.value.mb,
        PersonalDocumentType: this.spnftForm.value.typeOfDocument,
        PersonalDocumentNumber: this.spnftForm.value.numberOfDocument,
        PersonalDocumentIssuedDate: this.spnftForm.value.dateOfIssuringDocument ? this.spnftForm.value.dateOfIssuringDocument.split('.')[2] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[1] + '-' + this.spnftForm.value.dateOfIssuringDocument.split('.')[0] : '',
        PersonalDocumentExpirationDate: this.spnftForm.value.personalDocumentExpirationDate ? this.spnftForm.value.personalDocumentExpirationDate.split('.')[2] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[1] + '-' + this.spnftForm.value.personalDocumentExpirationDate.split('.')[0] : '',
        PersonalDocumentIssuedPlace: this.spnftForm.value.placeOfIssuringDocument ? this.spnftForm.value.placeOfIssuringDocument.toUpperCase() : '',
        IsPoliticianOrCloseAssociate: this.spnftForm.value.officialCloseFamily == 0 ? false : true,
        InOffice: this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.officialPeriod : '',
        RemarkIfYes: this.spnftForm.value.officialCloseFamily == 1 ? this.spnftForm.value.closeFamilyName : '',
        ClientAppliesThroughIntermediary: !this.spnftForm.value.cutomerAnotherPerson ? false : this.spnftForm.value.cutomerAnotherPerson == '1' ? true : false,
        IntermediaryType: this.spnftForm.value.cutomerAnotherPersonRole ? this.spnftForm.value.cutomerAnotherPersonRole : null,
        IntermediaryFirstname: this.spnftForm.value.firstnameOnBehalf ? this.spnftForm.value.firstnameOnBehalf.toUpperCase() : '',
        IntermediaryLastname: this.spnftForm.value.lastnameOnBehalf ? this.spnftForm.value.lastnameOnBehalf.toUpperCase() : '',
        IntermediaryJMBG: this.spnftForm.value.jmbgOnBehalf,
        IntermediaryDateOfBirth: this.spnftForm.get('dobOnBehalf').value ? this.spnftForm.get('dobOnBehalf').value.split('.')[2] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[1] + '-' + this.spnftForm.get('dobOnBehalf').value.split('.')[0] : '',
        IntermediaryPlaceOfBirth: this.spnftForm.value.settlementobOnBehalf ? this.spnftForm.value.settlementobOnBehalf.toUpperCase() : '',
        IntermediaryAddress: this.spnftForm.value.addressOnBehalf ? this.spnftForm.value.addressOnBehalf.toUpperCase() : '',
        IntermediaryPostalCode: this.spnftForm.value.postalCodeOnBehalf ? this.spnftForm.value.postalCodeOnBehalf.toString() : '',
        IntermediarySettlement: this.spnftForm.value.settlementOnBehalf ? this.spnftForm.value.settlementOnBehalf.toUpperCase() : '',
        IntermediaryPersonalDocumentType: this.spnftForm.value.idTypeOnBehalf,
        IntermediaryPersonalDocumentNumber: this.spnftForm.value.idNumberOnBehalf,
        IntermediaryPersonalDocumentIssuedDate: this.spnftForm.value.idDate ? this.spnftForm.value.idDate.split('.')[2] + '-' + this.spnftForm.value.idDate.split('.')[1] + '-' + this.spnftForm.value.idDate.split('.')[0] : '',
        IntermediaryPersonalDocumentIssuedPlace: this.spnftForm.value.idPlace ? this.spnftForm.value.idPlace.toUpperCase() : '',
        BusinessRelationshipClientPurpose: this.spnftForm.value.purposeOfBusinessRelation,
        BusinessRelationshipClientPurposeOther: this.spnftForm.value.purposeOfBusinessRelation == '3' ? this.spnftForm.value.purposeOfBusinessRelationOther : '',
        PropertyOrigin: this.spnftForm.value.originOfProperty,
        PropertyOriginOther: this.spnftForm.value.originOfProperty == '3' ? this.spnftForm.value.originOfPropertyOther : ''
      },
      PlatimatikForm: {
        OfferID: 0,
        Firstname: this.platimatikForm.value.firstname ? this.platimatikForm.value.firstname.toUpperCase() : '',
        Lastname: this.platimatikForm.value.lastname ? this.platimatikForm.value.lastname.toUpperCase() : '',
        Address: this.platimatikForm.value.address ? this.platimatikForm.value.address.toUpperCase() : '',
        PostalCode: this.platimatikForm.value.postalCode ? this.platimatikForm.value.postalCode.toString() : '',
        Settlement: this.platimatikForm.value.placeOfResidence ? this.platimatikForm.value.placeOfResidence.toUpperCase() : '',
        JMBG: this.platimatikForm.value.jmbg,
        Bank: this.platimatikForm.value.bankName,
        AccountNumber: this.platimatikForm.value.firstThreeAccountNumber + this.platimatikForm.value.middleAccountNumber + this.platimatikForm.value.lastTwoAccountNumber,
        BIC: this.platimatikForm.value.bankBic,
        ContractNumber: '',
        Currency: 1,
        FirstMandateFrom: this.platimatikForm.get('validityFirstTermFrom').value ? this.platimatikForm.get('validityFirstTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermFrom').value.split('.')[0] : '',
        FirstMandateTo: this.platimatikForm.get('validityFirstTermTo').value ? this.platimatikForm.get('validityFirstTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validityFirstTermTo').value.split('.')[0] : '',
        SecondMandateFrom: this.platimatikForm.get('validitySecondTermFrom').value ? this.platimatikForm.get('validitySecondTermFrom').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermFrom').value.split('.')[0] : '',
        SecondMandateTo: this.platimatikForm.get('validitySecondTermTo').value ? this.platimatikForm.get('validitySecondTermTo').value.split('.')[2] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[1] + '-' + this.platimatikForm.get('validitySecondTermTo').value.split('.')[0] : ''
      },

      UserID: this.userId,
      NotificationsAgreement: this.checkBoxesForm.value.confirmSMS == '1' ? true : false,
      Verified: this.checkBoxesForm.value.confirmVeracity,
      Verified2: this.checkBoxesForm.value.confirmData,
      Verified3: this.checkBoxesForm.value.confirmEmail == '1' ? true : false
    }

    let helthBool = false;
    if (
      !this.healthForm.value.threeMonthStayAbroad ||
      (this.healthForm.value.threeMonthStayAbroad == '0' && !this.healthForm.value.threeMonthStayAbroadDescription) ||
      !this.healthForm.value.deniedAcceptedRequest ||
      (this.healthForm.value.deniedAcceptedRequest == '0' && !this.healthForm.value.deniedacceptedRequestDescription) ||
      !this.healthForm.value.sportActivity ||
      (this.healthForm.value.sportActivity == '0' && !this.healthForm.value.sportActivityDescription) ||
      !this.healthForm.value.constantDoctorTreats ||
      (this.healthForm.value.constantDoctorTreats == '0' && !this.healthForm.value.constantDoctorTreatsDescription) ||
      !this.healthForm.value.specialMedicalExamination ||
      (this.healthForm.value.specialMedicalExamination == '0' && !this.healthForm.value.specialMedicalExaminationDescription) ||
      !this.healthForm.value.takingMedicines ||
      (this.healthForm.value.takingMedicines == '0' && !this.healthForm.value.takingMedicinesDescription) ||
      !this.healthForm.value.alcoholOrIntoxicants ||
      (this.healthForm.value.alcoholOrIntoxicants == '0' && !this.healthForm.value.alcoholOrIntoxicantsDescription) ||
      !this.healthForm.value.helpForAlcoholAddiction ||
      (this.healthForm.value.helpForAlcoholAddiction == '0' && !this.healthForm.value.helpForAlcoholAddictionDescription) ||
      !this.healthForm.value.consumeCigarettes ||
      (this.healthForm.value.consumeCigarettes == '0' && !this.healthForm.value.consumeCigarettesDescription) ||
      !this.healthForm.value.seriousIllness ||
      (this.healthForm.value.seriousIllness == '0' && !this.healthForm.value.seriousIllnessDescription) ||
      !this.healthForm.value.dangerAtWork ||
      (this.healthForm.value.dangerAtWork == '0' && !this.healthForm.value.dangerAtWorkDescription) ||
      !this.healthForm.value.tenYearMedicalTests ||
      (this.healthForm.value.tenYearMedicalTests == '0' && !this.healthForm.value.tenYearmedicalTestsDescription) ||
      !this.healthForm.value.thirtyDaysIncapable ||
      (this.healthForm.value.thirtyDaysIncapable == '0' && !this.healthForm.value.thirtyDaysIncapableDescription) ||
      !this.healthForm.value.levelOfInvaliditet ||
      (this.healthForm.value.levelOfInvaliditet == '0' && !this.healthForm.value.levelOfInvaliditetDescription) ||
      !this.healthForm.value.newFifteenthQuestion ||
      (this.healthForm.value.newFifteenthQuestion == '0' && !this.healthForm.value.newFifteenthQuestionDescription) ||

      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && !this.healthForm.value.familySickness) ||
      ((this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != 0 && this.personalForm.value.riderTB != null && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription)) ||

      !this.healthForm.value.nameOfDoctor ||
      !this.healthForm.value.agreeToHealthQuestionnaire
    ) {
      helthBool = true;
    } else {
      helthBool = false;
    }

    if (
      (this.healthForm.value.consumeCigarettes == '0' && this.insuredSumAndPremiumForm.value.cigarettesDaily == 0) ||
      (this.healthForm.value.consumeCigarettes == '1' && this.insuredSumAndPremiumForm.value.cigarettesDaily > 0)
    ) {
      this.errorTitle = "Odgovor na ponudi u vezi cigareta nije usklađen sa upitnikom. Molimo ispravite odgovor na ponudi.";
      this.modalService.open(this.alertModal, { centered: true })
      return;
    }

    // (this.healthForm.value.familySickness == '0' && !this.healthForm.value.familySicknessDescription) ||

    if (!this.hideExport) {
      this.errorTitle = "Niste izvršili izračunavanje";
      this.modalService.open(this.alertModal, { centered: true })
    } else {
      if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1') {
        this.errorTitle = "Ne možete kreirati digitalnu ponudu ukoliko je izabrana jednokratna uplata";
        this.modalService.open(this.alertModal, { centered: true })
      } else {
        if (!this.userSignature) {
          this.errorTitle = "Nemate potpis";
          this.modalService.open(this.alertModal, { centered: true })
        } else {
          if (
            ((this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && ((this.insuranceCoverageForm.value.incidentRadio == '1' && this.sentInformations.package1TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '2' && this.sentInformations.package2TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '3' && this.sentInformations.package3TotalPremiumRateYearly > 1500) || (this.insuranceCoverageForm.value.incidentRadio == '4' && this.sentInformations.package4TotalPremiumRateYearly > 1500))) || ((!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) && this.sentInformations.totalPremiumRateYearly > 1500) || (this.supplementaryIsnuranceHideAllBool && this.sentInformations.totalPremiumRateYearly > 1500)
          ) {
            this.errorTitle = "Ne možete napraviti digitalnu ponudu ukoliko godisnja premija nije manja od 1500 €";
            this.modalService.open(this.alertModal, { centered: true })
          } else {

            if (!this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              // console.log("Personal")
              this.offerModelFull.AdditionalInsuranceType = 0;
              this.offerModelFull.DeathByAccident = this.personalForm.value.deathByAccident;
              this.offerModelFull.AdditionalPremiumRate = this.sentInformations.personalizedPremiumRate;


              this.offerModelFull.AdditionalRiderDeath = this.personalForm.value.riderDeath;
              this.offerModelFull.AdditionalRiderTBType = Number(this.personalForm.value.tbType);
              this.offerModelFull.AdditionalRiderTB = this.personalForm.value.riderTB;

              if (this.personalForm.value.includeMSO == '0') {
                this.offerModelFull.IncludeMSO = false;
              } else {
                this.offerModelFull.IncludeMSO = true;
              }
              if (this.personalForm.value.includeDNA == '0') {
                this.offerModelFull.IncludeDNA = false;
              } else {
                this.offerModelFull.IncludeDNA = true;
              }
              if (this.personalForm.value.invalidityByAccident) {
                if (this.personalForm.value.surgery) {
                  this.offerModelFull.Surgery = this.personalForm.value.surgery;
                } else {
                  this.offerModelFull.Surgery = null;
                }
                if (this.personalForm.value.monthlyRent) {
                  this.offerModelFull.MonthlyRent = this.personalForm.value.monthlyRent;
                } else {
                  this.offerModelFull.MonthlyRent = null;
                }
                if (this.personalForm.value.daylyFee) {
                  this.offerModelFull.DailyFee = this.personalForm.value.daylyFee;
                } else {
                  this.offerModelFull.DailyFee = null
                }
                if (this.personalForm.value.treatmanExpenses) {
                  this.offerModelFull.TreatmentExpenses = this.personalForm.value.treatmanExpenses;
                } else {
                  this.offerModelFull.TreatmentExpenses = null;
                }
                this.offerModelFull.InvalidityByAccident = this.personalForm.value.invalidityByAccident;
              } else {
                this.offerModelFull.InvalidityByAccident = null;
                this.offerModelFull.Surgery = null;
                this.offerModelFull.MonthlyRent = null;
                this.offerModelFull.DailyFee = null;
                this.offerModelFull.TreatmentExpenses = null;
                this.offerModelFull.IncludeMSO = false;
                this.offerModelFull.IncludeDNA = false;
              }

            } else if (this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
              // console.log("Dopunsko")
              this.offerModelFull.AdditionalInsuranceType = this.insuranceCoverageForm.value.incidentRadio;
              this.offerModelFull.DeathByAccident = this.sentInformations.deathByAccident;
              this.offerModelFull.InvalidityByAccident = this.sentInformations.invalidityByAccident;
              this.offerModelFull.MonthlyRent = this.sentInformations.monthlyRent;
              this.offerModelFull.TreatmentExpenses = null;
              this.offerModelFull.DailyFee = null;
              this.offerModelFull.AdditionalRiderDeath = null;
              this.offerModelFull.AdditionalRiderTBType = null;
              this.offerModelFull.AdditionalRiderTB = null;

              switch (this.insuranceCoverageForm.value.incidentRadio) {
                case '1':
                  this.offerModelFull.AdditionalPremiumRate = this.sentInformations.package1PremiumRate;
                  this.offerModelFull.Surgery = null;
                  this.offerModelFull.IncludeMSO = false;
                  this.offerModelFull.IncludeDNA = false;
                  break;
                case '2':
                  this.offerModelFull.AdditionalPremiumRate = this.sentInformations.package2PremiumRate;
                  this.offerModelFull.Surgery = this.sentInformations.surgery;
                  this.offerModelFull.IncludeMSO = true;
                  this.offerModelFull.IncludeDNA = false;
                  break;
                case '3':
                  this.offerModelFull.AdditionalPremiumRate = this.sentInformations.package3PremiumRate;
                  this.offerModelFull.Surgery = this.sentInformations.surgery;
                  this.offerModelFull.DailyFee = this.sentInformations.dailyFee;
                  this.offerModelFull.IncludeMSO = false;
                  this.offerModelFull.IncludeDNA = false;
                  break;
                case '4':
                  this.offerModelFull.AdditionalPremiumRate = this.sentInformations.package4PremiumRate;
                  this.offerModelFull.Surgery = null;
                  this.offerModelFull.IncludeMSO = true;
                  this.offerModelFull.IncludeDNA = true;
                  break;
                default:
                  break;
              }
            } else {
              this.offerModelFull.AdditionalInsuranceType = 5;
              this.offerModelFull.DeathByAccident = null;
              this.offerModelFull.InvalidityByAccident = null;
              this.offerModelFull.Surgery = null;
              this.offerModelFull.TreatmentExpenses = null;
              this.offerModelFull.DailyFee = null;
              this.offerModelFull.MonthlyRent = null;
              this.offerModelFull.IncludeMSO = false;
              this.offerModelFull.IncludeDNA = false;
              this.offerModelFull.AdditionalRiderDeath = null;
              this.offerModelFull.AdditionalRiderTBType = null;
              this.offerModelFull.AdditionalRiderTB = null;
              this.offerModelFull.AdditionalPremiumRate = 0;
            }

            let mobileRegex = new RegExp('0[0-9]{7,9}')
            let postalCodeRegex = new RegExp('[0-9]{5}')
            // let emailRegex = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/g
            let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            // console.log(this.basicInfo.data.insuredEmail.toString())
            // console.log(emailRegex.test(this.basicInfo.data.insuredEmail.toString()))
            if (this.basicInfo.data.contractorType == '1') {
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !this.basicInfo.data.contractorPIB || !this.basicInfo.data.contractorResponsibleName || !this.basicInfo.data.contractorID || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13 || this.basicInfo.data.contractorPIB.length != 9 || this.basicInfo.data.contractorID.length != 8) {
                this.digitalService.addInfo(true);
              } else {
                if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                  this.digitalService.addInfo(true);
                } else {
                  if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.methodPayment) {
                    this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.validInsuranceAndSumPremium = true;
                  } else {
                    if (this.userValue) {
                      this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.calculcatorUsersBool = true;
                      this.validUser = true
                    } else {
                      if (helthBool) {
                        this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.healthQuestionnaireBool = true;
                      } else {
                        if (!this.fatcaForm.value.insuredLegalEntitySad || !this.fatcaForm.value.insuredTaxpayerSad || !this.fatcaForm.value.insuredTenPrecentShare || !this.fatcaForm.value.insuredFinancialInstitution) {
                          this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.noticeFatcaBool = true;
                        } else {
                          if (
                            !this.spnftForm.value.firstname || !this.spnftForm.value.lastname ||
                            !this.spnftForm.value.jmbg ||
                            !this.spnftForm.value.settlementob ||
                            !this.spnftForm.value.address ||
                            !this.spnftForm.value.postalCode ||
                            !this.spnftForm.value.citizenship ||
                            !this.spnftForm.value.numberOfDocument ||
                            !this.spnftForm.value.typeOfDocument ||
                            !this.spnftForm.value.dateOfIssuringDocument ||
                            !this.spnftForm.value.personalDocumentExpirationDate ||
                            !this.spnftForm.value.placeOfIssuringDocument ||
                            !this.spnftForm.value.cutomerAnotherPerson ||
                            (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                            (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                            !this.spnftForm.value.purposeOfBusinessRelation ||
                            (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                            !this.spnftForm.value.originOfProperty ||
                            (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                          ) {
                            this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                            this.validSPNFT = true;
                            this.formSpnftBool = true;
                          } else {
                            if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                              if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                                this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                                this.validPLATIMATIK = true;
                                this.formPlatimatikBool = true
                              } else {
                                if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                  console.log("Mogu da se posalju podaci!")
                                  this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                                } else {
                                  this.errorTitle = "Morate da potvrdite saglasnost";
                                  this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                                }
                              }
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            } else {
              // console.log(mobileRegex.test(this.basicInfo.data.contractorPhonenumber))
              if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.contractorJMBG || !this.basicInfo.data.contractorEmail || !this.basicInfo.data.contractorAddress || !this.basicInfo.data.contractorPostalCode || !this.basicInfo.data.contractorAddressOfDelivery || !this.basicInfo.data.contractorPostalCodeOfDelivery || !this.basicInfo.data.contractorPhonenumber || !mobileRegex.test(this.basicInfo.data.contractorPhonenumber) || this.basicInfo.data.contractorJMBG.length != 13) {
                // console.log("Prosle basic")
                // console.log(this.basicInfo)
                this.digitalService.addInfo(true);
              } else {
                if (!this.basicInfo.data.contractorFirstname || !this.basicInfo.data.contractorLastname || !this.basicInfo.data.insuredJMBG || this.basicInfo.data.insuredJMBG.length != 13 || !this.basicInfo.data.insuredAddress || !this.basicInfo.data.insuredMobile || !this.basicInfo.data.insuredJob || !this.basicInfo.data.insuredPostalCode || !this.basicInfo.data.insuredEmail || !emailRegex.test(this.basicInfo.data.insuredEmail.toString()) || !mobileRegex.test(this.basicInfo.data.insuredMobile)) {
                  // console.log('prosole insured')
                  this.digitalService.addInfo(true);
                } else {
                  if (!this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.currencyPayment || !this.insuredSumAndPremiumForm.value.methodPayment) {
                    this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                    this.validInsuranceAndSumPremium = true;
                  } else {
                    // console.log("Prosle currency")
                    if (this.userValue) {
                      this.usersBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                      this.calculcatorUsersBool = true;
                      this.validUser = true
                    } else {
                      // console.log("Prosli korisnici")
                      if (helthBool) {
                        this.healthBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                        this.healthQuestionnaireBool = true;
                      } else {
                        // console.log("Prosao zdravstveni")
                        if (!this.fatcaForm.value.citizenshipSad || !this.fatcaForm.value.texpayerSad) {
                          this.fatcaBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                          this.noticeFatcaBool = true;
                        } else {
                          if (
                            !this.spnftForm.value.firstname ||
                            !this.spnftForm.value.lastname ||
                            !this.spnftForm.value.jmbg ||
                            !this.spnftForm.value.settlementob ||
                            !this.spnftForm.value.address ||
                            !this.spnftForm.value.postalCode ||
                            !this.spnftForm.value.citizenship ||
                            !this.spnftForm.value.numberOfDocument ||
                            !this.spnftForm.value.typeOfDocument ||
                            !this.spnftForm.value.dateOfIssuringDocument ||
                            !this.spnftForm.value.personalDocumentExpirationDate ||
                            !this.spnftForm.value.placeOfIssuringDocument ||
                            !this.spnftForm.value.cutomerAnotherPerson ||
                            (this.spnftForm.value.officialCloseFamily == '1' && (!this.spnftForm.value.closeFamilyName || !this.spnftForm.value.officialPeriod)) ||
                            (this.spnftForm.value.cutomerAnotherPerson == '1' && (!this.spnftForm.value.cutomerAnotherPerson || !this.spnftForm.value.cutomerAnotherPersonRole || !this.spnftForm.value.firstnameOnBehalf || !this.spnftForm.value.lastnameOnBehalf || !this.spnftForm.value.settlementOnBehalf || !this.spnftForm.value.jmbgOnBehalf || !this.spnftForm.value.addressOnBehalf || !this.spnftForm.value.postalCodeOnBehalf || !this.spnftForm.value.idNumberOnBehalf || !this.spnftForm.value.idTypeOnBehalf || !this.spnftForm.value.idDate || !this.spnftForm.value.idDate || !this.spnftForm.value.idPlace)) ||
                            !this.spnftForm.value.purposeOfBusinessRelation ||
                            (this.spnftForm.value.purposeOfBusinessRelation == '3' && !this.spnftForm.value.purposeOfBusinessRelationOther) ||
                            !this.spnftForm.value.originOfProperty ||
                            (this.spnftForm.value.originOfProperty == '3' && !this.spnftForm.value.originOfPropertyOther)
                          ) {
                            this.spnftBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                            this.validSPNFT = true;
                            this.formSpnftBool = true;
                          } else {
                            console.log("Prosao spnft")
                            if (this.insuredSumAndPremiumForm.value.methodPayment == '4') {
                              if (!this.platimatikForm.value.firstname || !this.platimatikForm.value.lastname || !this.platimatikForm.value.address || !this.platimatikForm.value.postalCode || !this.platimatikForm.value.placeOfResidence || !this.platimatikForm.value.jmbg || !this.platimatikForm.value.firstThreeAccountNumber || !this.platimatikForm.value.middleAccountNumber || !this.platimatikForm.value.lastTwoAccountNumber || !this.platimatikForm.value.bankName || !this.platimatikForm.value.bankBic) {
                                this.platimatikBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
                                this.validPLATIMATIK = true;
                                this.formPlatimatikBool = true
                              } else {
                                console.log("Prosao platiomatik")
                                if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                  console.log("Mogu da se posalju podaci!")
                                  this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                                } else {
                                  this.errorTitle = "Morate da potvrdite saglasnost";
                                  this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                                }
                              }
                            } else {
                              if (this.checkBoxesForm.value.confirmVeracity && this.checkBoxesForm.value.confirmData && this.checkBoxesForm.value.confirmSMS && this.checkBoxesForm.value.confirmEmail) {
                                console.log("Mogu da se posalju podaci!")
                                this.modalService.open(this.emailModal, { size: 'xl', centered: true, backdrop: 'static', keyboard: false })
                              } else {
                                this.errorTitle = "Morate da potvrdite saglasnost";
                                this.modalService.open(this.alertModal, { centered: true, backdrop: 'static', keyboard: false })
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  setTBRole() {
    let index = this.roles.findIndex(x => x.productRoleID == 3) // 3 za produkciju 8 za test
    if (this.personalForm.value.riderTB != '' && this.personalForm.value.riderTB != null && this.personalForm.value.riderTB != 0 && !this.supplementaryInsuranceBool && !this.supplementaryIsnuranceHideAllBool) {
      if (index == -1) {
        this.roles.push({
          allowMultipleClients: false,
          maxClientsPerRole: 0,
          productRole: {
            createdBy: null,
            createdByID: 1,
            createdOn: "2020-06-08T12:54:32.007",
            id: 3, //3 za produkciju 8 za test
            lastModifiedBy: null,
            lastModifiedByID: null,
            lastModifiedOn: null,
            name: "U slučaju teže bolesti",
            productTypesRoles: []
          },
          productRoleID: 3, //3 za produkciju 8 za test
          productType: 2
        })
      }
    } else {
      if (index != -1) {
        this.roles.splice(index, 1)
      }
    }
  }

  openSignOnDistanceModal(modal) {
    this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
  }
  blockSendingBool: boolean = true
  openRiskModal(modal, DBool) {
    if (DBool) {
      this.offerModelFull.IdentificationType = 1
      this.blockSendingBool = false
      this.offerService.createProgresiveDigitalOffer(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.blockSendingBool = true
            this.offerId = x;
            this.riskAssessmentForm.reset();
            this.modalService.open(modal, { size: 'xl', backdrop: 'static', keyboard: false })
            if (this.spnftForm.value.officialCloseFamily == '1') {
              this.riskAssessmentForm.get('question11').setValue('0');
              this.riskAssessmentForm.get('question11').disable();
            } else {
              this.riskAssessmentForm.get('question11').enable();
            }
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraftModelFull.IdentificationType = 1
      this.updateDraft(1);
    }
  }
  addRiskAssessment() {
    if (this.riskAssessmentForm.valid) {
      let risk = new RiskAssessment({
        OfferID: this.offerId,
        Q1: this.riskAssessmentForm.value.question1 == '0' ? true : false,
        Q2: this.riskAssessmentForm.value.question2 == '0' ? true : false,
        Q3: this.riskAssessmentForm.value.question3 == '0' ? true : false,
        Q4: this.riskAssessmentForm.value.question4 == '0' ? true : false,
        Q5: this.riskAssessmentForm.value.question5 == '0' ? true : false,
        Q6: this.riskAssessmentForm.value.question6 == '0' ? true : false,
        Q7: this.riskAssessmentForm.value.question7 == '0' ? true : false,
        Q8: this.riskAssessmentForm.value.question8 == '0' ? true : false,
        Q9: this.riskAssessmentForm.value.question9 == '0' ? true : false,
        Q10: this.riskAssessmentForm.value.question10 == '0' ? true : false,
        Q11: this.riskAssessmentForm.get('question11').value == '0' ? true : false,
        Q12: this.riskAssessmentForm.value.question12 == '0' ? true : false,
        Q13: this.riskAssessmentForm.value.question13 == '0' ? true : false,
        Q14: this.riskAssessmentForm.value.question14 == '0' ? true : false,
        Q15: this.riskAssessmentForm.value.question15 == '0' ? true : false,
        Q16: this.riskAssessmentForm.value.question16 == '0' ? true : false,
        Q17: this.riskAssessmentForm.value.question17 == '0' ? true : false,
        Q18: this.riskAssessmentForm.value.question18 == '0' ? true : false,
        Q19: this.riskAssessmentForm.value.question19 == '0' ? true : false,
        Q20: this.riskAssessmentForm.value.question20 == '0' ? true : false,
        Q21: this.riskAssessmentForm.value.question21 == '0' ? true : false,
        Q22: this.riskAssessmentForm.value.question22 == '0' ? true : false,
        Q23: this.riskAssessmentForm.value.question23 == '0' ? true : false,
        Q24: this.riskAssessmentForm.value.question24 == '0' ? true : false,
        Q25: this.riskAssessmentForm.value.question25 == '0' ? true : false,
        Q26: this.riskAssessmentForm.value.question26 == '0' ? true : false,
        Q27: this.riskAssessmentForm.value.question27 == '0' ? true : false,
        Q28: this.riskAssessmentForm.value.question28 == '0' ? true : false,
        Q29: this.riskAssessmentForm.value.question29 == '0' ? true : false,
        UnableToGetData: false
      })
      this.offerService.createRiskAssessment(risk)
        .then(
          x => {
            // this.modalService.dismissAll();
            this.signDistance();
            // this.modalService.open(modal, { size: 'lg', backdrop: 'static' })
          }
        )
    } else {
      // console.log("now checked wverything")
      this.errorTitle = "Niste odgovorili na sva pitanja";
      this.modalService.open(this.alertModal, { centered: true })
    }
  }
  signDistance() {
    console.log(this.offerId);
    this.offerService.sentSignRequest(this.offerId)
      .then(
        x => {
          console.log(x);
          this.successTitle = "Uspešno ste kreirali digitalnu ponudu";
          this.modalService.dismissAll();
          this.modalService.open(this.succesModal, { centered: true, backdrop: 'static', keyboard: false })
          this.resetEverything()
          this.insuranceUsers = []
          this.formPlatimatikBool = false;
          this.formSpnftBool = false;
          this.noticeFatcaBool = false;
          this.healthQuestionnaireBool = false;
          this.calculcatorUsersBool = false;
          this.validInsuranceAndSumPremium = false;
          this.validUser = false;
          this.validSPNFT = false;
          this.validPLATIMATIK = false;
          this.insuredBlock.nativeElement.scrollIntoView({ behavior: 'smooth' })
        }
      )
  }


  openSignOnSiteModal(modal) {
    this.modalService.open(modal, { size: 'lg', backdrop: 'static', keyboard: false })
  }
  offerId: number
  signOnSpot(DBool) {
    console.log(this.offerModelFull);
    if (DBool) {
      this.offerModelFull.IdentificationType = 0
      this.offerService.createProgress(this.offerModelFull)
        .then(
          (x: any) => {
            console.log(x);
            this.offerId = x;
            this.offerService.createFromDraftOffer(this.offerId)
              .then(
                x => {
                  this.offerService.sendLocalDocuments(this.offerId)
                    .then(
                      x => {
                        this.modalService.dismissAll();
                        this.resetEverything()
                        this.insuranceUsers = []
                        this.formPlatimatikBool = false;
                        this.formSpnftBool = false;
                        this.noticeFatcaBool = false;
                        this.healthQuestionnaireBool = false;
                        this.calculcatorUsersBool = false;
                        this.validInsuranceAndSumPremium = false;
                        this.validUser = false;
                        this.validSPNFT = false;
                        this.validPLATIMATIK = false;
                        this.router.navigate(['/sign-documents-on-spot/' + this.offerId]);
                        this.router.navigate([]).then(r => { window.open('/sign-documents-on-spot/' + this.offerId, '_blank') })
                      }
                    )
                },
                (x: any) => {
                  console.log(x)
                  this.errorTitle = x.error;
                  this.modalService.open(this.alertModal, { centered: true })
                }
              )
          },
          (x: any) => {
            console.log(x)
            this.errorTitle = x.error;
            this.modalService.open(this.alertModal, { centered: true })
          }
        )
    } else {
      this.updateDraftModelFull.IdentificationType = 0
      this.updateDraft(2);
    }
  }


  roles;
  getRoles(num) {
    // this.roles = this.productRoleService.getRoleByProduct(num)
    // console.log(num)
    this.productRoleService.getRoleByProduct(num)
      .subscribe(
        (res) => {
          this.roles = res;
          // console.log(this.roles)
        }
      )
  }

  resetCalculation() {
    this.hideExport = false;
    if (this.insuredSumAndPremiumForm.value.cigarettesDaily > 0) {
      this.healthForm.get('consumeCigarettes').setValue('0')
      this.healthForm.get('consumeCigarettesDescription').setValue(this.insuredSumAndPremiumForm.value.cigarettesDaily.toString())
    } else {
      this.healthForm.get('consumeCigarettes').setValue('1')
      this.healthForm.get('consumeCigarettesDescription').setValue('')
    }
    if (this.basicInfo.data.insuredJMBG) {
      if (this.basicInfo.data.insuredJMBG.length >= 7) {
        if (this.basicInfo.data.insuredJMBG.substring(4, 5) == '0') {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('2' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        } else {
          if (parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)) != this.insuredSumAndPremiumForm.value.accessAge) {
            this.insuredSumAndPremiumForm.get('accessAge').setValue(parseInt(this.insuredSumAndPremiumForm.get('insuranceStart').value.split('.')[2]) - parseInt('1' + this.basicInfo.data.insuredJMBG.substring(4, 7)))
            this.hideExport = false
          }
        }
      }
    }
  }

  disableSuppInsurance() {
    if (this.insuredSumAndPremiumForm.value.oneTimePayment == '1') {
      this.basicInfoForm.get('noSupplementaryInsurance').setValue(true)
    } else {
      this.basicInfoForm.get('noSupplementaryInsurance').setValue(false)
    }
    this.resetCalculation()
    this.noSupplementaryHide()
  }

  resetEverything() {
    this.insuredSumAndPremiumForm.reset({ currencyPayment: '0', currencyPayout: '0', cigarettesDaily: '0' })
    this.todayDate = new Date()
    this.todayDate.setDate(1);
    this.todayDate.setMonth(this.todayDate.getMonth() + 1);
    this.insuredSumAndPremiumForm.get('insuranceStart').setValue(formatDate(this.todayDate, 'dd.MM.yyyy', 'en'));
    this.basicInfoForm.reset();
    this.healthForm.reset({ agreeToHealthQuestionnaire: true })
    this.fatcaForm.reset({
      citizenshipSad: '1',
      texpayerSad: '1',
      insuredLegalEntitySad: '1',
      insuredTaxpayerSad: '1',
      insuredTenPrecentShare: '1',
      insuredFinancialInstitution: '1'
    })
    this.spnftForm.reset({ officialCloseFamily: '0' })
    this.platimatikForm.reset()
    this.platimatikForm.get('validityFirstTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 5), 'dd.MM.yyyy', 'en'))
    this.platimatikForm.get('validitySecondTermFrom').setValue(formatDate(new Date(this.todayDate.getFullYear(), this.todayDate.getMonth(), 20), 'dd.MM.yyyy', 'en'))
    this.insuranceCoverageForm.reset({ incidentRadio: '3', planRadio: '2' })
    this.personalForm.reset({ includeMSO: '0', includeDNA: '0', planRadio: '2', tbType: '' })
    this.hideExport = false
    this.checkBoxesForm.reset({ confirmVeracity: false, confirmData: false, confirmSMS: '1', confirmEmail: '1', offer: true, redemptionAndCapitalization: true, proContract: true, terms: true, doctor: true })
    // this.removeInfoService.sendOfferID(true);
    this.insuranceUsers = []
    this.validUser = false;
    this.validSPNFT = true;
    this.validPLATIMATIK = false;
    this.calculcatorUsersBool = false;
    this.healthQuestionnaireBool = false;
    this.noticePersonalityBool = false;
    this.noticeFatcaBool = false;
    this.formSpnftBool = false;
    // this.basicInfo = new BasicInformations({});
  }

  userId;
  userSignature;
  getUser() {
    this.userService.getUser()
      .then(
        (x: { id: Number, signature: String }) => {
          this.userId = x.id;
          this.userSignature = x.signature;
          // console.log(x)
        }
      )
  }

  get validInsuredSumAndPremiumForm() {
    return this.insuredSumAndPremiumForm.controls;
  }

  get validHealthForm() {
    return this.healthForm.controls;
  }

}
